module.exports = {
  PleaseChooseJob: 'Пожалуйста, выберите бланк бронирования.',
  NoSearchingInfo: 'Не введена информация для запроса.',
  NoRecordMeetTheConditions: 'Не найдено записей, соответствующих требованиям.',
  Error: 'Произошла ошибка.',
  Locked: 'Заблокировано',
  UnKnownStatus: 'Статус неизвестен',
  CloseDetailWindow: 'Закрыть детальное окно',
  AdvancedSearch: 'Расширенный поиск',
  NoCustomersFoundPleaseRefreshCache: 'Клиент не существует, попробуйте сбросить кэш!',
  SelectedMonthHasBeenClosed: 'Выбранный месяц уже закрыт для учета.',
  AccountClosedSuccessfully: 'Закрытие учета успешно.',
  PleaseSelectClosingRecord: 'Пожалуйста, выберите запись о закрытии учета.',
  ClosingRecordHasBeenApproved: 'Запись о закрытии учета проверена, отмена невозможна.',
  CancelTheClosingRecord: 'Вы уверены, что хотите отменить запись о закрытии учета?',
  AccountClosingRecordCanceled: 'Запись о закрытии учета отменена',
  CannotBeCancelledAfterApproval: 'После проверки запись о закрытии учета нельзя отменить, вы уверены?',
  ClosingDateAfterCancelingTheApproval: 'После отмены проверки можно отменить дату закрытия учета, вы уверены?',
  BillingType: 'Тип выставления счета',
  ByTicket: 'Оплата по счету',
  InvitationListTip: 'Клиент уже отправил дополнительные материалы, повторное приглашение на сверку разблокирует страницу дополнений клиента и позволит редактировать и повторно отправлять! Продолжить?',
  PleaseClickFirst: 'Пожалуйста, сначала нажмите "Подтвердить сверку".',
  PleaseSelectTheFeeYouNeedToPush: 'Пожалуйста, выберите расходы, которые нужно синхронизировать.',
  PleaseSelectTheFeeYouNeedToCopy: 'Пожалуйста, выберите расходы, которые нужно скопировать.',
  PleaseSeparateMultipleEmailAddressesWithCommas: 'Несколько адресов электронной почты разделяйте запятыми.',
  PleaseSupplementOtherMailboxes: 'Пожалуйста, укажите другие адреса электронной почты.',
  ContactAndEmailAreNotMaintained: 'Контакты и электронная почта не указаны.',
  PleaseSelectTheMaintainedContactAndMailbox: 'Пожалуйста, выберите указанные контакты и электронную почту.',
  SelectMailbox: 'Выбрать электронную почту',
  InvoiceUuidCannotBeBlank: 'UUID счета не может быть пустым.',
  TheSettlementUnitIDCannotBeEmpty: 'ID расчетной единицы не может быть пустым!',
  PleaseEnterYourEmailAddress: 'Пожалуйста, введите адрес электронной почты.',
  Monthly: 'Месячный расчет',
  PleaseSelectTheDataYouWantToExport: 'Пожалуйста, отметьте данные для экспорта.',
  NoData: 'Нет данных',
  PleaseSelectJob: 'Пожалуйста, выберите операцию.',
  ThisJobIsNotWorkingCanNotBeEdited: 'Эта операция не в активном состоянии, редактирование невозможно.',
  CanNotEditJob: 'Нельзя изменить операцию {0}!',
  TheSameSalesAndOperationsConfirmThatYouWantToSave: 'Продажи и операции совпадают, подтвердить сохранение?',
  SolicitationTypeIsNotTheSameAsSubBillDoYouWantToSaveIt: 'Тип приема груза отличается от накладной, сохранить?',
  WHNoRepeatedContinue: 'Номер склада повторяется, продолжить?',
  Prompt: 'Подсказка',
  MblNoRepeatedContinue: 'Номер MBL повторяется, подтвердить сохранение?',
  MblNoRepeatedNotCurrentCompanyContinue: 'Введенный вами номер не принадлежит к текущему филиалу или отделу операции, подтвердите продолжение.',
  MblNoRepeatedNotCurrentCompanyContinueAll: 'Введенный вами MBL повторяется и не принадлежит к текущему филиалу или отделу операции, подтвердите продолжение.',
  MblNoSiRepeatedContinue: 'Основной номер повторяется, подтвердить сохранение?',
  MblNoRepeatedNotSave: 'Повторение MB/L №【{0}】не допускается для сохранения.',
  AlreadyAssociatedWithOtherBranches: 'Другой филиал уже связан с 【{0}】, выберите другого партнера для связи!',
  CustomerRefNoRepeatedContinue: 'Референсный номер операции повторяется, подтвердить сохранение?',
  HblNoRepeatedContinue: 'Номер HBL повторяется, подтвердить сохранение?',
  SoNoRepeatedContinue: 'Номер SoNo повторяется, подтвердить сохранение?',
  HAWBRepeatedContinue: 'Дублирование номеров HAWB-накладных не допускается',
  HBLRepeatedContinue: 'Дублирование номеров HBL-накладных запрещено',
  IATACodeRepeat: 'Код IATA не должен повторяться',
  AirCodeRepeat: 'Авиакомпании не должны дублироваться',
  AuthenticationFailed: 'Ошибка проверки!',
  SaveSuccessfully: 'Успешно сохранено',
  InvoiceNoLength: 'Номер счета слишком длинный, проверьте',
  Success: 'Успешно',
  ShutOutSuccessfully: 'Успешный отказ от таможенного оформления',
  CancellationSuccessfully: 'Аннулирование прошло успешно',
  CancelShutOutSuccessfully: 'Отмена отказа от таможенного оформления прошла успешно',
  ThisTemplateCouldNotBeResolvedPleaseContactCS: 'Не удалось обработать шаблон, обратитесь в службу поддержки.',
  CurrentBranchIsNotSelectedCannotAddNewBookings: 'Не выбрано текущее отделение, нельзя добавить заказ на бронирование.',
  CompanySelectedIsHQCannotAddNewBookings: 'Выбрана головная компания, добавление заказа на бронирование невозможно.',
  TheLastOfTheNewStateHasBeenRestored: 'Восстановлено предыдущее состояние добавления.',
  CancelMotify: 'Отменить текущие изменения?',
  Info: 'Информация',
  NoBusinessCanBeSplit: 'Нет операций для разделения.',
  SplittingErrorContainerInformationIsEmpty: 'Ошибка разделения: информация о упаковке отсутствует.',
  IsNotOperationStatus: 'Не в состоянии оперативного управления.',
  SureDelete: 'Подтверждаете удаление?',
  DeleteSuccessfully: 'Успешно удалено',
  CustomerIssuing: 'Не отмечен пункт "HBL клиент выписывает самостоятельно", перейдите на вкладку HBL и отметьте',
  CustomerIssuingTips: 'Статус выпуска накладной: ожидание оплаты/накладная задержана. Продолжить загрузку типа файла "клиент выписывает самостоятельно"?',
  DirectBusiness: 'Прямая накладная',
  SplittingBusiness: 'Раздельная накладная',
  NoPermissionToEditTheJob: 'У вас нет прав на редактирование данной накладной.',
  HaveBusinessHasBeenSubmittedCannotBeShutOut: 'В выбранных записях есть операции на финансовой проверке, проверьте.',
  HaveBusinessHasBeenShutOuted: 'В выбранных записях есть операции отказа от таможенного оформления, проверьте.',
  HaveBusinessHasBeenCancellation: 'В выбранных записях есть аннулированные операции, проверьте.',
  PleaseRemoveThisTicketFromMblThenShutOutBatch: 'Удалите выбранные дочерние накладные из основной, затем откажитесь от таможенного оформления.',
  PleaseRemoveAllTicketsFromMblThenShutOutBatch: 'Удалите все дочерние накладные из выбранной основной, затем откажитесь от таможенного оформления.',
  HasChargeToShutOutTip: 'Будет выполнен отказ от таможенного оформления с оплатой для операций с расходами, подтверждаете?',
  NoneChargeToShutOutTip: 'Будет выполнен отказ от таможенного оформления без оплаты для операций без расходов, подтверждаете?',
  BusinessHasBeenSubmittedCannotBeShutOut: 'Операция отправлена на финансовую проверку, отказ от таможенного оформления невозможен.',
  NoPermissionToCancelTheShutOut: 'У вас нет прав на отмену отказа от таможенного оформления.',
  ConfirmToCancelTheShutOut: 'Подтверждаете отмену отказа от таможенного оформления?',
  Warning: 'Предупреждение',
  NoChargeToShutOut: 'Отказ от таможенного оформления без оплаты',
  HasChargeToShutOut: 'Отказ от таможенного оформления с оплатой',
  PleaseConfirmTheShutOut: 'Подтверждаете отказ от таможенного оформления?',
  SendStatusChangeNotification: 'Отправить уведомление об изменении статуса',
  StatusChangeNotification: 'Уведомление об изменении статуса (для внутренних сотрудников)',
  OptionIsChecked: 'Если отметить этот пункт, будут отправлены письма с уведомлением об изменении SOP для внутренних и внешних пользователей',
  OnlyBeUsedForChangingCosts: 'Можно вносить только изменения, связанные с расходами',
  DoNotMakeAnyChanges: 'Изменения запрещены (все расходы будут удалены)',
  IfDoNotClearTheConfirmationFeeDoNotAllowFreeShutOut: 'Если не очистить подтвержденные расходы, отказ от таможенного оформления без оплаты невозможен.',
  PleaseRemoveThisTicketFromMblThenShutOut: 'Удалите эту дочернюю накладную из основной, затем откажитесь от таможенного оформления.',
  PleaseRemoveAllTicketsFromMblThenShutOut: 'Удалите все дочерние накладные из этой основной, затем откажитесь от таможенного оформления.',
  TicketsMustBeVoted: 'Дочерние накладные должны быть прикреплены к основной',
  NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance: 'Предварительная отправка невозможна, так как не все подлежащие оплате расходы проверены.',
  CommitSuccessfully: 'Отправка успешно завершена.',
  LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL: 'Накладные LCL нельзя отправить отдельно, отправьте основную накладную.',
  GenerateExpensesBasedOnCurrentSellingPriceAndBuyingPrice: 'Сформировать расходы на основе текущих цен продажи и покупки?',
  PlatformCodeNotFound: 'Авиафрахт с кодом платформы A/F не найден в статьях расходов.',
  Withdraw: 'Отозвать',
  AlreadyReturn: 'Возвращено.',
  AlreadyWithdraw: 'Отозвано.',
  ReturnAction: 'Операция возврата',
  IsConfirm: 'Подтвердить?',
  Return: 'Вернуть',
  BatchReturnSucceeded: 'Массовый возврат успешно выполнен: {0}',
  BatchReturnPreSubmitCheck: 'Возврат возможен только для документов в статусе предварительной отправки.',
  BatchReturnSubmitCheck: 'Отзыв возможен только для документов в статусе отправки.',
  BusinessIsNotCommittedAndCannotBeWithdrawn: 'Операция не в статусе "Отправлено", отзыв невозможен.',
  BusinessIsNotPreCommittedAndCannotBeReturn: 'Операция не в статусе "Предварительная отправка", возврат невозможен.',
  BatchUnlockLockedBillsOfAccountsReceivable: 'Массовая разблокировка возможна только для документов с заблокированными дебиторскими расходами!',
  lowBalanceTips: 'Недостаточный баланс для распознавания деклараций, невозможно распознать все файлы массовой загрузки.<br/>1) Продолжить загрузку файлов в историю без распознавания деклараций<br/>2) Пополнить баланс и загрузить позже (по умолчанию файлы не загружаются и декларации не анализируются)',
  lowBalanceTips1: 'Продолжить загрузку файлов',
  lowBalanceTips2: 'Загрузить после пополнения',
  BatchUnlockLockingBillsOfAccountsReceivable: 'Массовая блокировка возможна только для документов с разблокированными дебиторскими расходами!',
  BatchUnlockLockingBillsOfAccountsPayable: 'Массовая блокировка возможна только для документов с разблокированными кредиторскими расходами!',
  BatchUnlockLockedBillsOfAccountsPayable: 'Массовая разблокировка возможна только для документов с заблокированными кредиторскими расходами!',
  UnlockChargeStatus: 'Подтвердить разблокировку статуса расходов {0}?',
  LockingChargeStatus: 'Подтвердить блокировку статуса расходов {0}?',
  SuccessfullyUnlockedFeesInBatch: 'Массовая разблокировка расходов {0} успешно выполнена: {1}',
  SuccessfullylockingedFeesInBatch: 'Массовая блокировка расходов {0} успешно выполнена: {1}',
  ThereAreFeesReceivableNotInvoicedPrint: 'Есть невыставленные счета по дебиторской задолженности, все равно распечатать?',
  ThereAreFeesReceivableNotInvoicedSubmit: 'Есть невыставленные счета по дебиторской задолженности, все равно отправить?',
  VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'Документ будет отправлен на финансовую проверку. Подтвердите загрузку всех файлов перед отправкой. Продолжить?',
  SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'Документ будет отправлен на проверку руководителю. Подтвердите загрузку всех файлов перед отправкой. Продолжить?',
  PleaseInputTheSalesInformationAndPrints: 'Введите данные продавца перед печатью!',
  PleaseInputTheSalesInformationAndSubmit: 'Введите данные продавца перед отправкой!',
  FollowingTheSingleDidNotEnterTheSalesInformation: 'В следующих документах отсутствуют данные продавца:',
  PleaseEnterAndPrint: 'Введите данные перед печатью!',
  PleaseSelectAWaterBillRecord: 'Выберите запись платежного поручения.',
  PleaseEnterAndSubmit: 'Введите данные перед отправкой!',
  WithCostsAbroadWithoutValidBillingNumberYouCannotPrintAnAnalysisOfProfitTable: 'Есть зарубежные расходы без валидного номера счета, печать анализа прибыли невозможна!',
  WithCostsAbroadWithoutValidBillingNumberCannotBeSubmitted: 'Есть зарубежные расходы без валидного номера счета, отправка невозможна!',
  BulkSubmissionOfWrittenSubmissionsOnlyList: 'Массовая отправка возможна только для предварительно отправленных документов!',
  BulkSubmissionOfWrittenPreSubmissionsOnlyList: 'Массовая предварительная отправка возможна только для документов в рабочем статусе!',
  MakeSureToSubmitAListOftheNFinancialAuditPlease1: 'Подтвердите отправку',
  MakeSureToSubmitAListOftheNFinancialAuditPlease12: 'документа на финансовую проверку?',
  BatchSubmittedSuccessfully: 'Массовая отправка успешно завершена',
  BatchSubmittedPreSuccessfully: 'Массовая предварительная отправка успешно завершена',
  TheSelectedDocumentInconsistentNatureOfTheBooking: 'Выбранные документы имеют разный характер согласованных цен',
  TheSelectedDocumentIsNotTheSameVoyage: 'Выбранные документы относятся к разным рейсам/судам',
  SelectTheData: 'Выберите данные',
  NoSelectedDataOrAreNotOperationalStatus: 'Данные не выбраны или не в рабочем статусе',
  TheSelectedServicesIncludeLockedServices: 'Среди выбранных операций есть заблокированные',
  SureYouWantToRemoveTheCharge: 'Вы уверены, что хотите удалить расходы?',
  NoCostToRemove: 'Нет расходов для удаления.',
  NoBusinessOrIsNotOperationalState: 'Операция не выбрана или не находится в рабочем состоянии.',
  MakeSureToDelegateTheBusiness: 'Вы уверены, что хотите поручить эту операцию?',
  ErrorReadingInformation: 'Ошибка чтения информации.',
  OrderTypeChangeTip: 'После смены типа заказа часть заполненных данных будет удалена. Подтверждаете изменение?',
  BusinessDateCanNotNull: 'Дата операции не может быть пустой.',
  TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners: 'Получатель не поддерживает информацию о текущей компании в партнерах.',
  ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain: 'Электронная доверенность по этой операции уже отправлена. Отправить снова?',
  DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize: 'Не найден соответствующий тип шаблона [BOOKING] и название шаблона [Морская экспортная грузовая доверенность]. Продолжить оформление?',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: 'Филиал текущего агента по бронированию не поддерживает партнерские отношения с нашей компанией.',
  TheBranchCompanyOfCurrentForwardingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: 'Филиал текущего агента по отправке не поддерживает партнерские отношения с нашей компанией.',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI: 'Филиал текущего агента в порту назначения не поддерживает партнерские отношения с нашей компанией.',
  TheBranchCompanyOfUnExchangeAgent: 'В настоящее время филиал, к которому принадлежит агент по обмену заказами, не поддерживает своих партнеров среди партнеров',
  TheBranchCompanyOfUnOurCompany: 'В настоящее время филиалы транспортных компаний не поддерживают своих партнеров среди партнеров',
  TheOppositeSideHasScceptedNoNeedToReCommission: 'Контрагент уже принял запрос, повторное оформление не требуется!',
  SuccessfullySent: 'Отправлено успешно.',
  NoSendingGoodsInfo: 'Нет информации о грузе, который нужно отправить',
  NoAssociatedBusiness: 'Нет связанных операций!',
  NoAssociatedContainerInfo: 'Нет информации о контейнерах для отправки.',
  PleaseEnterFleetInformatio: 'Введите информацию об автопарке.',
  ThisBoxIsNotAllowedToBeDeleted: 'Этот контейнер нельзя удалить.',
  FailedToQueryTheAssociatedBusiness: 'Не найдены связанные операции.',
  RepeatedWarehouseNo: 'Повторяющийся номер складского размещения.',
  NoStorageInfo: 'Нет информации о поступлении на склад.',
  TheJobIsIncorrectPleaseRefreshThePageOrContactTheAdministrator: 'Некорректный рабочий лист. Обновите страницу или свяжитесь с администратором!',
  ConsignationCompanyCannotBeNull: 'Организация-доверитель не может быть пустой.',
  FLCLTypeCannotBeNull: 'Тип консолидации не может быть пустым.',
  POLCannotBeNull: 'Порт отправления не может быть пустым.',
  IfThereIsATransferTheTransferPortCannotBeNull: 'При наличии транзита порт перевалки не может быть пустым.',
  PortOfDischargeCannotBeNull: 'Порт выгрузки не может быть пустым.',
  PortOfDestinationCannotBeNull: 'Порт назначения не может быть пустым.',
  SalesCannotBeNull: 'Продавец не может быть пустым.',
  SalesBranchCompanyIsNullPleaseReSelectSales: 'Филиал продавца пуст. Пожалуйста, выберите продавца заново!',
  SalesDepartmentIsNullPleaseReSelectSales: 'Выберите отдел продаж!',
  DateOfDepartureCannotBeLaterThanDateOfArrival: 'Дата отплытия не может быть позже даты прибытия.',
  NominatedAgentCannotBeNull: 'Агент по назначению груза не может быть пустым!',
  FLCLTypeCannotBeNull2: 'Тип погрузки не может быть пустым!',
  ItemNoCannotBeNull: 'Номер проекта не может быть пустым!',
  EQSizeCannotBeNull: 'Тип контейнера не может быть пустым!',
  EQSizeCannotBeNull2: 'Должен быть хотя бы один контейнер!',
  DearYouCanOnlySelectYourOwnCustomers: 'Дорогой, вы можете выбирать только своих клиентов.',
  DepartmentCannotBeNull: 'Отдел не может быть пустым.',
  CyCutoffDateCannotBeLaterThanDepartureDate: 'Дата закрытия не может быть позже даты отплытия.',
  BargeCutoffDateCannotBeLaterThanCyCutoffDate: 'Дата закрытия баржи не может быть позже даты закрытия!',
  ContainerSealInfoHasBeenEnteredCannotBeDeleted: 'Введена информация о пломбах контейнера, удаление невозможно.',
  RelevantInstallationInfoHasBeenEnteredCannotBeDeleted: 'Введена информация о погрузке на паллеты, удаление невозможно.',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated: 'Изменен расчетный вес. Обновить существующие расходы, рассчитанные по весу? Уже выставленные счета и накладные не обновятся.',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated2: 'Изменен расчетный вес. Обновить существующие расходы, рассчитанные по весу? Уже выставленные счета, накладные, заявки на оплату и проводки не обновятся.',
  CurrencyChangeConfirm: 'Валюта покупки/продажи изменена. Обновить существующие затраты? Затраты, уже выставленные в счетах, инвойсах, заявках на оплату или списанные, не будут обновлены',
  PriceTypeChangeConfirm: 'Тип цены покупки/продажи изменен. Обновить существующие затраты? Затраты, уже выставленные в счетах, инвойсах, заявках на оплату или списанные, не будут обновлены',
  PriceUpdateConfirm: 'Покупательская/продажная цена изменилась. Подтвердите, нужно ли обновить расходы, рассчитанные на основе тарифного веса за единицу для покупательской и продажной цен? Расходы, для которых составлены счета, выставлены счета-фактуры, поданы заявки на оплату и произведены списания, не будут обновлены',
  TheChargedWeightHasBeenChanged: 'Изменен расчетный вес. Обновить существующие расходы, рассчитанные по весу?',
  WeightChangeToRefreshCostBasedOnWeightPrice: 'Изменен вес. Обновить существующие расходы, рассчитанные по весу? Уже выставленные счета, накладные, заявки на оплату, проводки и связанные коносаменты не обновятся.',
  WeightChangeToRefreshCostBasedOnWeightTonPrice: 'Изменен вес. Обновить существующие расходы, рассчитанные по весу (тонны)? Уже выставленные счета, накладные, заявки на оплату, проводки и связанные коносаменты не обновятся.',
  CubageChangeToRefreshCostBasedOnCubagePrice: 'Изменен объем. Обновить существующие расходы, рассчитанные по объему? Уже выставленные счета, накладные, заявки на оплату, проводки и связанные коносаменты не обновятся.',
  InsideQuantityChangeToRefreshCostBasedOnCubagePrice: 'Количество мелких мест изменилось. Обновить стоимость, рассчитанную по количеству мелких мест? Стоимость, по которой уже выставлен счет, проведена оплата, сделана заявка на платеж, проведено списание или которая связана с коносаментом, не будет обновлена.',
  ChangeToRefreshCostBasedOnCubagePrice: 'Изменено количество мелких мест, вес брутто, объем или расчетный вес. Обновить стоимость, рассчитанную по количеству мелких мест, весу, объему или расчетному весу? Стоимость, по которой уже выставлен счет, проведена оплата, сделана заявка на платеж, проведено списание или которая связана с коносаментом, не будет обновлена.',
  DistributedSuccessfully: 'Комплектация успешно завершена',
  BusinessReferenceNoReduplicated: 'Дублирование бизнес-референса',
  BookingAgentCannotBeNull: 'Агент по бронированию не может быть пустым',
  DateOfDepartureCannotBeNull: 'Дата отплытия не может быть пустой',
  TheMainInterfaceDoesNotExist: 'Главный интерфейс не существует',
  FeesHaveBeenUsedForThisUnit: 'Данная единица измерения уже используется в расходах. Пожалуйста, сначала измените единицы измерения в соответствующих расходах, а затем удалите!',
  TheChargingUnitIsUsedByAnExistingChargePlan: 'Данная единица тарификации уже используется в тарифных планах. Пожалуйста, сначала измените единицы измерения в соответствующих тарифных планах, а затем удалите',
  TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst: 'Бизнес-номер главной накладной для сборного груза еще не сгенерирован. Пожалуйста, сначала сохраните главную накладную.',
  TheSubBillHasBeenConsolidatedAndCannotBeRemoved: 'Данная накладная уже включена в сборный груз и не может быть извлечена.',
  PleaseSelectSubBills: 'Пожалуйста, выберите накладную.',
  PleaseSaveTheChangedDataOrExitTheEditStateAndThenCloseTheModule: 'Пожалуйста, сначала сохраните изменения или выйдите из режима редактирования, а затем закройте модуль.',
  MblNoIsNull: 'Номер MB/L пуст',
  SONoIsNull: 'Номер S/O пуст',
  NoVesselVoyageInformation: 'Отсутствует информация о названии судна и рейсе',
  ObtainSuccessfully: 'Данные успешно получены',
  PleaseSelectCopyType: 'Пожалуйста, выберите тип копирования.',
  NoTargetShippingCompanyFoundHerePleaseRefreshTheCache: 'Данная судоходная компания не найдена. Пожалуйста, обновите кэш!',
  BlIsConfirmed: 'Коносамент уже подтвержден.',
  ThisHblIsCombinedAndCannotBeEdited1: 'Данный HBL уже включен',
  ThisHblIsCombinedAndCannotBeEdited2: 'Редактирование невозможно.',
  ToOrederBlCannotBeTelexReleased: 'Для TO ORDER электронный релиз невозможен',
  PleaseInputBlSerialNumberFirst: 'Пожалуйста, сначала введите порядковый номер коносамента!',
  PleaseSelectTheListToBeMergedInto: 'Пожалуйста, выберите документы для включения!',
  PleaseInputBussinessNo: 'Пожалуйста, введите бизнес-номер!',
  NoSelectedContainerInformation: 'Информация о контейнерах не выбрана.',
  PleaseSelectData: 'Пожалуйста, отметьте данные',
  OnlySelectOneData: 'Можно выбрать только одну запись',
  Count: 'Количество накладных',
  AreYouSureYouWantToRemoveTheSubBill: 'Подтверждаете извлечение накладной?',
  RemovedSuccesfully: 'Успешно удалено.',
  NoSubBillsToSplit: 'Нет накладных для разделения.',
  SoNoCannotBeNull: 'Номер S/O не может быть пустым.',
  CancelTheCurrentQuery: 'Отменить текущий запрос?',
  SelectTheOrderYouWantToJoin: 'Пожалуйста, выберите заявку на бронирование для добавления.',
  HasJoinIntoMbl: 'Уже добавлено в главную накладную.',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue: 'Название судна, рейс, перевозчик, агент по бронированию, агент в порту назначения, ETD, ETA и информация о складе для выбранной накладной не совпадают с главной накладной. Система изменит накладную. Продолжить?',
  ContainerNoDoesNotComplyWithTheNumberingRules: 'Номер контейнера не соответствует правилам нумерации.',
  SealNoHasBeenChanged: 'Номер пломбы уже изменялся.',
  PleaseSelectTheDesiredPrintVgm: 'Пожалуйста, выберите VGM для печати.',
  DeleteTheVgmInformation: 'Вы хотите удалить данную информацию VGM?',
  PleaseEnterEnglish: 'Пожалуйста, введите на английском.',
  PleaseEnterTheShippingCompanyInformation: 'Имеются транспортные расходы. Пожалуйста, введите информацию о транспортной компании!',
  SameJobtruckOrderNo: 'Дублирование номера заявки на автомобиль для door-to-door контейнеризации. Пожалуйста, исправьте!',
  SureYouRemoveThisNData1: 'Подтверждаете удаление этой',
  SureYouRemoveThisNData2: 'записи?',
  AreYouSureYouWantToSendACarOrder: 'Вы уверены, что хотите отправить заявку на автомобиль?',
  AreYouSureYouWantToModifyACarOrder: 'Вы уверены, что хотите изменить заявку на автомобиль?',
  AreYouSureYouWantToRevokeACarOrder: 'Вы уверены, что хотите отменить заказ?',
  ThisCarOrderIsSended: 'После успешного распределения заказа повторное распределение невозможно, изменения можно вносить только через корректировку заказа.',
  ThisCarOrderCanOnlyBeModifiedAfterSending: 'Корректировка заказа возможна только после его распределения.',
  ThisCarOrderIsSendedNoAddUsage: 'После успешного распределения транспортной накладной добавление контейнеров запрещено.',
  ThisCarOrderCanOnlyBeRevokedIsUnApproved: 'Отмена заказа возможна только в статусе "Не принят".',
  ThisCarOrderIsChanged: 'Внимание: данные квитанции изменены.',
  DeleteFailed: 'Ошибка удаления',
  Failure: 'Ошибка',
  DispatchSuccess: 'Распределение успешно',
  ModifiedTruckOrderSuccess: 'Корректировка успешна',
  RevokeTruckOrderSuccess: 'Отмена успешна',
  DispatchFailed: 'Ошибка при распределении',
  ModefiedTruckOrderFaild: 'Ошибка при корректировке',
  RevokeTruckOrderFaild: 'Ошибка при отмене',
  VgmWeightingMethod: 'Метод взвешивания VGM',
  LdpWarn: 'Для замороженных грузов одновременно требуется минимум одна строка',
  WxpWarn: 'Для опасных грузов одновременно требуется минимум одна строка',
  Transfer: 'Смена судна агентом',
  ReasonForDeletion: 'Причина удаления',
  ReasonForDeletionNotEmpty: 'Причина удаления обязательна',
  VesselRegex: 'Только латинские буквы и цифры, не более 35 символов',
  BlNumberRegex: 'Только цифры',
  DanClass: 'Должно быть от 1 до 9,9',
  CubageRegex: 'Диапазон от 0,001 до 2000,999',
  RowPrefix: '№ декларации {0}',
  UpdateVesselVoyNo: 'Изменить номер рейса судна',
  UpdateVesselVoyNoError: 'Нельзя изменить номер рейса для неотправленного манифеста',
  InputVesselVoyNo: 'Введите обновлённый номер рейса судна',
  ShipNotRegistered: 'Судно не зарегистрировано',
  LoadManifest: 'Загрузить манифест',
  ModificationFailed2: 'Перераспределение не удалось',
  ModifiedSuccessfully: 'Перераспределение выполнено',
  NoDelete: 'Нет данных для отправки манифеста на удаление',
  SendFailed: 'Ошибка отправки',
  SaveFailed: 'Ошибка сохранения',
  ViewWarehouseEntryPhotos: 'Просмотр фото поступления на склад',
  DistributeFailedNoFoundRelatedStorageRecord: 'Ошибка комплектации: соответствующие складские записи не найдены!',
  SureYouWantToCancelTheBindingToTheStorageData: 'Подтверждаете отвязку от складских данных?',
  QueryFailed: 'Ошибка запроса',
  SelectDeclarations: 'Выберите таможенную декларацию.',
  SelectCustomsInformation: 'Выберите таможенные сведения.',
  SelectCustomsRecord: 'Выберите таможенную запись.',
  TheNumberOfTenBitCodeYouEnteredIsNotEnough: 'Упс! Введённый десятизначный код недостаточной длины.',
  OperatingCompanyCannotBeNull: 'Поле "Хозяйствующий субъект" обязательно для заполнения.',
  DateOfCustomsDeclarationCannotBeNull: 'Дата таможенного оформления обязательна.',
  PleaseSelectStatusOfCustomsDeclaration: 'Выберите статус таможенного оформления.',
  CargoDetailsWEIGHTBannotBeNull: 'Вес груза обязателен.',
  CargoDetailsAMOUNTBannotBeNull: 'Количество груза обязательно.',
  CargoDetailsCustomsDutyRateBannotBeNull: 'Ставка таможенной пошлины обязательна.',
  CargoDetailsCustomsDutiesBannotBeNull: 'Таможенная пошлина обязательна.',
  CargoDetailsIncrementRateCannotBeNull: 'Ставка НДС обязательна.',
  CargoDetailsIncrementValueDutyBannotBeNull: 'НДС обязателен.',
  CargoDetailsConsumptionDutyRateBannotBeNull: 'Ставка акциза обязательна.',
  CargoDetailsConsumptionDutyBannotBeNull: 'Акциз обязателен.',
  CargoDetailsCurrencyBannotBeNull: 'Валюта обязательна.',
  CargoDetailsExchangeBannotBeNull: 'Курс обмена обязателен.',
  CargoDetailsCargoPriceBannotBeNull: 'Стоимость товара обязательна.',
  CargoDetailsTaxBannotBeNull: 'Налоги обязательны.',
  CargoDetailsTaxRateBannotBeNull: 'Налоговая ставка обязательна.',
  ImportSuccessful1: 'Импорт успешен',
  ImportSuccessful2: 'шт.',
  ImportFailed: 'Ошибка импорта',
  CargoDetailsIsNotSelected: 'Спецификация груза не выбрана.',
  PleaseSelectUnRelatedTradeDetailData: 'Выберите несвязанные товарные данные.',
  SelectTheBillingObject: 'Выбор объекта расчётов',
  NoChargeForTheSettlementOfDomesticObjects: 'Нет объектов расчётов с внутренними расходами.',
  CancelAudit: 'Отмена проверки',
  ChargesAudit: 'Проверка расходов',
  ThereAreFeesCantBeDeletedPleaseRecheck: 'Содержит неудаляемые расходы, проверьте.',
  TheChargesHaveBeenSettledByFinancialAccountAndCannotBeAmended: 'Расходы уже проведены финансовым отделом, изменение невозможно.',
  RedChargeOrRedChargedCannotBeEditAdjustAgainPleaseSelectNewAdjustment: 'Сторнированные или сторнирующие расходы нельзя повторно корректировать, выберите добавление корректировки.',
  RedChargeOrRedChargedCannotBeDeletedPleaseReselect: 'Сторнированные или сторнирующие расходы нельзя удалить, выберите заново.',
  PleaseRefresh: 'Расходы были изменены другим пользователем, обновите страницу.',
  ChargeItemCannotBeNull: 'Название расхода не может быть пустым!',
  MeasureCannotBeNull: 'Единица измерения расхода не может быть пустой!',
  SettlementPartyCannotBeNull: 'Объект расчёта не может быть пустым!',
  CurrencyCannotBeNull: 'Валюта не может быть пустой!',
  AmountCannotBeNull: 'Количество не может быть пустым!',
  UnitRateCannotBeNull: 'Цена за единицу не может быть пустой!',
  CustomsSeclarationServiceIsNotSelectedInBookingCannotAdd: 'Не выбрана услуга таможенного оформления при бронировании, добавление невозможно:',
  WaerhouseServiceIsNotSelectedInBookingCannotAdd: 'Не выбрана услуга складирования при бронировании, добавление невозможно:',
  HaulageServiceIsNotSelectedInBookingCannotAdd: 'Не выбрана транспортная услуга при бронировании, добавление невозможно:',
  ChargeIsNotSelectedOrAllChargesSubmit: 'Расходы не выбраны или уже все отправлены.',
  ChargeIsNotSelectedOrNotInTheSubmissionStatus: 'Расходы не выбраны или не находятся в статусе отправки.',
  OperationSuccessfully: 'Операция успешно выполнена.',
  PayablesIsNull: 'Нет данных о подлежащих оплате расходах.',
  ReceivalbeIsNull: 'Нет данных о подлежащих получению расходах.',
  CopyThePayablesSuccessfullyTotallyOfNItems1: 'Копирование подлежащих оплате расходов успешно, всего создано',
  CopyThePayablesSuccessfullyTotallyOfNItems2: 'расходов.',
  CopyTheReceivablesSuccessfullyTotallyOfNItems1: 'Копирование подлежащих получению расходов успешно, всего создано',
  CopyTheReceivablesSuccessfullyTotallyOfNItems2: 'расходов.',
  NoPayablesCanBeCopiedThereMayBeSameChargeItems: 'Нет подлежащих оплате расходов для копирования, возможно, уже есть расходы с таким же названием.',
  NoReceivablesCanBeCopiedThereMayBeSameChargeItems: 'Нет подлежащих получению расходов для копирования, возможно, уже есть расходы с таким же названием.',
  CopyChargeSuccessfullyTotallyOfNItems1: 'Копирование расходов успешно, всего создано',
  NoChargeCanBeCopiedThereMayBeSameChargeItems: 'Нет расходов для копирования, возможно, уже есть расходы с таким же названием.',
  TheCurrentlyRelevantBusinessInformationIsNull: 'Связанная бизнес-информация отсутствует.',
  PleaseSelectCharges: 'Выберите расходы.',
  SelectChargesAreInControl: 'Выбранные расходы взяты под контроль.',
  SelectedChargesAreCancelledControlling: 'Контроль над выбранными расходами снят.',
  PleaseGoToTheFCLFreightInquiryModuleToCheckFreightDetails: 'Перейдите в модуль проверки тарифов FCL для просмотра деталей тарифа!',
  PleaseGoToTheAirFreightInquiryModuleToCheckFreightDetails: 'Перейдите в модуль проверки авиатарифов для просмотра деталей тарифа!',
  DoYouNeedToInviteOthersToConfirmTheCharges: 'Вам нужно отправить запрос на подтверждение расходов?',
  TheMailHasBeenSentPleaseNoteAndHaveACheck: 'Письмо отправлено, проверьте, пожалуйста!',
  PleaseSelectReceivableCharges: 'Выберите один подлежащий получению расход.',
  PleaseSelectPayableCharges: 'Выберите один подлежащий оплате расход.',
  OnlyAuditChargesHaveBeenSubmitted: 'Можно проверять только отправленные расходы.',
  NoChargesToAudit: 'Нет расходов для проверки, проверьте ответственного или статус расходов.',
  NoChargesToUnAudit: 'Нет расходов для отмены проверки, проверьте ответственного или статус расходов.',
  NoChargesToReject: 'Нет расходов для отклонения, проверьте ответственного или статус расходов.',
  YouAreNotACostSpecifiedByTheReviewerCannotAuditTheCharges: 'Убедитесь, что вы являетесь ответственным за проверку всех расходов.',
  SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill: 'Выбранные расходы включают полностью погашенные, добавить их в счёт?',
  AllSelectedFeesWillBeVerifiedPleaseChooseAgain: 'Все выбранные расходы уже полностью погашены, выберите заново.',
  IncludeFullyWrittenOffCosts: 'Выбранные затраты включают полностью списанные суммы. Добавить их в счёт?',
  AuditSuccessfully: 'Проверка успешно завершена.',
  CancelSuccessfully: 'Отмена успешно выполнена.',
  PleaseSelect1ChargeDetail: 'Выберите детализацию расходов.',
  NoPriceToMeetTheQueryCriteria: 'Не найдены подходящие цены.',
  Prepaid: 'Предоплата.',
  Collect: 'Оплата при получении.',
  PrePayTheSamePrice: 'Единая цена для предоплаты и оплаты при получении.',
  RefreshRateFailed: 'Не удалось обновить тариф!',
  PleaseSelectThePrice: 'Пожалуйста, выберите тариф!',
  Invalidation: 'Недействителен',
  Normal: 'Активен',
  suspension: 'Отменён',
  NoPickingUp: 'Не принимается',
  Inquiry: 'Запрос цены',
  Tension: 'Ограниченный',
  OverStowage: 'Перегружен',
  CreateBill: 'Создать счета по валютам расходов',
  SplitBill: 'Разделить счета по исходным валютам',
  PleaseBeNotedThatThisRateIsUnderSuspendSailing: 'Обратите внимание: тариф отменён!',
  PleaseBeNotedThatThisRateIsUnavailableNow: 'Обратите внимание: тариф не принимается!',
  PleaseBeNotedThatThisRateIsOnlyForPartOfEQType: 'Обратите внимание: некоторые типы контейнеров не принимаются!',
  PleaseBeNotedThatThisRateIsUnderOverbookedStatus: 'Обратите внимание: тариф перегружен!',
  TheOriginOfSelectedRateIsDifferentFromBookingAgent: 'Источник выбранного тарифа не совпадает с агентом бронирования',
  Unconfirmed: 'Не подтверждено',
  Confirmed: 'Подтверждено',
  Receivable: 'Дебиторская',
  Payable: 'Кредиторская',
  Bill: 'Счёт',
  TheBillDoesNotConfirm: 'Счёт не подтверждён',
  SureYouWantToCancel: 'Вы уверены, что хотите отменить?',
  StateModifiedSuccessfully: 'Статус успешно изменён.',
  NoInternalCostsToBilling: 'Нет внутренних расходов для выставления счёта',
  NoSettlementUnit: 'Нет расчётной единицы.',
  CheckoutObjectIsNullNoAdditionalCostsConfirmationSlip: 'Объект расчёта пуст, нельзя добавить подтверждение расходов.',
  ClearingUpInvoicingInformationWasNotSuccessfullyRead: 'Не удалось прочитать реквизиты плательщика.',
  YouDontHavePermissionToEditBills: 'У вас нет прав на редактирование кредиторских счетов.',
  YouDontHavePermissionToDeleteBills: 'У вас нет прав на удаление кредиторских счетов.',
  HaveNoPermissionToDeleteBillsCreatedByOtherUsers: 'Нет доступа к удалению счетов, созданных другими пользователями',
  NoSelectedBill: 'Счёт не выбран.',
  ClearingTheObjectDoesNotExistPleaseTryResettingTheCache: 'Объект расчёта не существует, попробуйте сбросить кеш.',
  BillSaveSuccessfully: 'Счёт успешно сохранён',
  BillingObjectIsNull: 'Объект счёта пуст.',
  ChargeCannotBeEmpty: 'Расходы не могут быть пустыми.',
  TaxesAndTaxRatesDoesNotMatchTheData: 'Несоответствие данных по налогу и ставке.',
  InvoicingHeadCannotBeEmpty: 'Реквизиты плательщика обязательны',
  CurrencyExchangeRateIsNotMaintained1: 'Валюта',
  CurrencyExchangeRateIsNotMaintained2: 'Курс валют не установлен.',
  FeeCurrencyMustBeTheSame: 'Валюта расходов должна быть одинаковой.',
  NoForeignFeeBilling: 'Нет зарубежных расходов для выставления счёта.',
  ThisJobIsNotWorkingCanNotBeDeleted: 'Этот счёт не в активном состоянии, удаление невозможно.',
  SureYouWantToDeleteTheBilling: 'Вы уверены, что хотите удалить этот счёт?',
  SureAuditTheBill: 'Подтверждаете проверку этого счёта?',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided: 'Этот счёт уже отправлен в финансовый отдел, аннулирование невозможно.',
  ThisOrderHasBeenRevokedNotARepeatedAction: 'Этот счёт уже аннулирован, повторное действие невозможно.',
  DomesticBillsCannotBeVoided: 'Внутренние счета нельзя аннулировать',
  TheBillHasBeenConfirmedAndCannotBeVoided: 'Счёт подтверждён, аннулирование невозможно <br/> Для аннулирования сначала отмените подтверждение',
  ThisVerificationHasBeenDoneAndCannotBeVoided: 'По этому счёту уже проведён зачёт, аннулирование невозможно.',
  AccountIsClosedAnyOperationIsNotAllowed: 'Учёт закрыт, операции запрещены',
  ThisFormIsLockedAndCannotBeVoided: 'Этот документ заблокирован и не может быть аннулирован',
  ThisFormIsLockedAndBillingGroup: 'К этому документу привязана сверка, аннулирование невозможно',
  ConfirmTheCancellationOfTheBill: 'Подтверждаете аннулирование этого счёта?',
  ConfirmTheCancellationOfTheBill2: 'Подтверждаете аннулирование выбранных счетов?',
  TheBillHasBeenRevoked: 'Счёт аннулирован.',
  NoSelectSettlement: 'Объект расчёта не выбран.',
  BillOfExchangeCannotBeEmpty: 'Курс валюты для счёта не может быть пустым',
  CollectingAdvanceBillingAndGeneralExpensesCannotBeTogether: 'Нельзя объединять инкассо, авансовые и обычные платежи в одном счёте',
  TheBillNumberIsCreatedSuccessfully: 'Номер счёта успешно создан',
  TheWordCorrespondingNetworkNameOrTheOverseasAgentNetworkManagementCodeHasNotBeenMaintained: 'Не удалось сгенерировать номер счёта: не указано название сетевого управления или двухбуквенный код для зарубежного агента',
  EnterTheShareProportion: 'Введите процент распределения.',
  PleaseSelectACurrency: 'Выберите валюту.',
  PleaseEnterTheBillingObject: 'Введите объект расчёта.',
  PleaseAddCosts: 'Добавьте расходы.',
  TheAmountOfBillCannotBeEqualTo: 'Сумма счёта не может быть равна 0',
  PleaseEnterTheNameOfTheCosts: 'Введите название расхода.',
  PleaseEnterTheQuantityOfTheCosts: 'Введите количество единиц расхода.',
  PleaseEnterThePriceOfTheCosts: 'Введите цену за единицу расхода.',
  PleaseSelectTheCostToRemove: 'Выберите расходы для удаления.',
  CollectingInconsistentWithTheTotalAdvance: 'Суммы инкассо и авансовых платежей не совпадают!',
  TheBillHasBeenInvoicedAndCannotBeDeleted: 'Этот счёт уже выставлен, удаление невозможно',
  LoadFailed: 'Ошибка загрузки',
  PlatformCodeAlreadyExists: 'Код платформы уже существует!',
  NameCannotBeRepeated: 'Китайские или английские названия статей доходов/расходов не должны повторяться!!!',
  ChineseNameCannotBeBlank: 'Китайское название статьи доходов/расходов не может быть пустым!!!',
  CannotBeModified: 'Используется в операциях, изменение названия невозможно',
  PleaseSelectAServiceItem: 'Выберите услугу',
  Overseas: 'Зарубежные',
  Domestic: 'Внутренние',
  PleaseSelectTheDesiredPrintInformation: 'Выберите информацию для печати',
  ThereIsAnErrorReadingWriteOffInformation: 'Ошибка чтения информации актов списания',
  TheBookingDoesNotExistAndCannotBeAdded: 'Букинг не существует, добавление невозможно.',
  PleaseEnter: 'Введите минимум 2 символа для поиска',
  PleaseEnterTheCode: 'Введите код, название для нечёткого поиска...',
  PleaseEnterTheCode2: 'Введите (минимум 2 символа) код, название для нечёткого поиска...',
  PleaseEnterTheContent: 'Введите содержимое',
  PleaseSelectDataBeforeOperation: 'Выберите данные для операции',
  NoPortRecordMeeting: 'Не выбраны подходящие записи портов, выберите заново!',
  DeleteTheSelectedRecord: 'Удалить выбранные записи?',
  DoYouConfirmThatYouWantToDelete: 'Подтверждаете удаление?',
  DeletionCancelled: 'Удаление отменено',
  EditCancelled: 'Редактирование отменено',
  PleaseSelectARecordToEdit: 'Выберите запись для редактирования',
  PleaseFillInTheCorrectFiveDigitPortCode: ' 请填写正确的港口五位代码. ',
  DeleteFail: 'Ошибка удаления!',
  DeleteSucceeded: 'Удаление успешно!',
  DisplayRuleCannotBeEmpty: 'Правила отображения не могут быть пустыми!',
  OperationRequirementsCannotBeEmpty: 'Требования к операции не могут быть пустыми!',
  OperationRequirementsCannotBeGreaterThan: 'Длина требований к операции не должна превышать 2048 символов!',
  NewPortRequestSucceeded: 'Требования к новому порту успешно добавлены',
  EditPortRequestSucceeded: 'Изменение требований к порту прошло успешно',
  ConfirmDelete: 'Подтверждение удаления',
  IsItUsedForMAWB: 'Используется ли для MAWB',
  IsItUsedForHAWB: 'Используется ли для HAWB',
  AddPortRequirementsAirport: 'Добавить требования к порту (аэропорт)',
  EditPortRequirementsAirport: 'Редактировать требования к порту (аэропорт)',
  PleaseSelectARecordToDelete: 'Выберите запись для удаления',
  BackPageTip: 'После [возврата на предыдущую страницу] информация, введенная на странице страхования, будет удалена. Подтверждаете возврат?',
  WarmReminder: 'Дружеское напоминание',
  GoBack: 'Вернуться на предыдущую страницу',
  ReturnToHomepage: 'Вернуться на главную страницу',
  HomepageNotSupportImport: 'На главной странице грузового страхования пока нет поддержки прямого импорта страхования',
  PortInformationEditedSuccessfully: 'Редактирование информации о порту прошло успешно',
  AirlineInformationEditedSuccessfully: 'Редактирование информации об авиакомпании прошло успешно',
  SuccessfullyAddedAirlineInformation: 'Добавление информации об авиакомпании прошло успешно',
  SuccessfullyAddedPortInformation: 'Добавление информации о порту прошло успешно',
  GetBack: 'Извлечь',
  FailedToInquiryCustomsDeclarationInformation: 'Не удалось запросить таможенную информацию:',
  PleaseSelectARecord: 'Пожалуйста, выберите запись.',
  NewDocuments: 'Создать новый документ',
  EditDocuments: 'Редактировать документ',
  FileTypeCannotBeEmpty: 'Тип файла не может быть пустым!',
  FileNumberCannotBeEmpty: 'Номер файла не может быть пустым',
  FileNumberAlreadyExists: 'Номер файла уже существует.',
  DataEnabledSuccessfully: 'Данные успешно активированы.',
  DataDisabledSuccessfully: 'Данные успешно отключены.',
  Error2: 'Ошибка',
  TheDocumentHasBeenSaved: 'Документ сохранен',
  TheCustomsBrokerCannotBeEmpty: 'Таможенный брокер не может быть пустым.',
  NoInformationCanBeQueried: 'Нет таможенной информации для запроса.',
  ErrorSavingBusinessState: 'Ошибка сохранения статуса операции',
  OrderInformationWasSuccessfullyUpdated: 'Информация о заказе успешно обновлена.',
  NoExternalUpdateInformation: 'Нет внешней информации для обновления',
  ExternalInformationWasSuccessfullyUpdated: 'Внешняя информация успешно обновлена',
  NodeStatusIsNotPreserved: 'Статус узла не сохранен.',
  TheNodeAffinityForTheMailTemplateIsNotMaintained: 'Шаблон электронной почты, связанный с узлом, не поддерживается.',
  DoNotLocateAnAssociatedPrintTemplateType: 'Не найден связанный тип печатного шаблона.',
  TheEmailWasSentPleaseNoteTheQuery: 'Письмо отправлено, пожалуйста, проверьте!',
  PleaseSelectAFile: 'Пожалуйста, выберите файл!',
  SureYouWantToDeleteFiles: 'Вы уверены, что хотите удалить файл?',
  EmailAddressCannotBeEmpty: 'Адрес электронной почты не может быть пустым.',
  UploadSuccess: 'Загрузка успешна:',
  UploadFailed: 'Ошибка загрузки:',
  FileSizeExceedsMBYouCannotUpload: 'Размер файла превышает 20 МБ, загрузка невозможна.',
  DoNotSelectedCategory: 'Категория файла не выбрана.',
  PleaseSelectAJob: 'Пожалуйста, выберите рабочий лист.',
  PleaseSelectTheSameTypeOfJob: 'Пожалуйста, выберите рабочие листы одного типа',
  NotStart: 'Не начато',
  PleaseSelectABusinessStatus: 'Пожалуйста, выберите статус операции',
  PleaseSelectABusinessStatusDetails: 'Пожалуйста, выберите детали статуса операции',
  EditedSuccessfully: 'Изменения успешно сохранены',
  PleaseContactTheSuperiorUnlocked: 'Из-за превышения кредитного лимита данная накладная заблокирована для печати. Обратитесь к руководству для разблокировки!',
  CanSuccessfullyPrint: 'Печать завершена успешно?',
  ConfirmToPrint: 'Подтверждение печати',
  CorrespondsToThePrintTemplateDoesNotFind: 'Соответствующий шаблон печати не найден',
  FailedToGetTheTemplateType: 'Не удалось получить тип шаблона!',
  NoSelectedTemplate: 'Шаблон не выбран.',
  BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow: 'Групповой перевод судна выполнен успешно. Закрыть всплывающее окно?',
  BulkTranferSuccessWhetherYouWantToCloseThePopUpWindow: 'Групповой перевод вагона выполнен успешно. Закрыть всплывающее окно?',
  NoFeesCanBeDeleted: 'Нет расходов для удаления.',
  NoSelectedCharge: 'Расходы не выбраны.',
  NoChargeCanBeSaved: 'Нет расходов для сохранения.',
  ChargeNameCannotBeEmpty: 'Название расхода не может быть пустым.',
  ClearingTheObjectCannotBeNull: 'Объект расчета не может быть пустым.',
  BusinessNumberIs0: 'Количество операционных номеров равно 0.',
  CustomerIsNULL: 'Клиент не указан',
  TheCarrierIsEmpty: 'Перевозчик не указан,',
  AgentIsNULL: 'Бронирующий агент/агент по замене документов не указан,',
  AgentIsNULL2: 'Зарубежный агент/агент порта назначения не указан,',
  CustomsIsNull: 'Таможенный брокер не указан,',
  TerminalCompanyIsNull: 'Стивидорная компания не указана,',
  TheObjectCannotBeUsedAsTheDefaultSettlement: 'Не может быть объектом расчета по умолчанию.',
  AddSuccessfully: 'Успешно добавлено.',
  DisplaysTheCostOfUpdatingResults: 'Показать результаты обновления расходов',
  TotalCost1: 'Всего',
  TotalCost2: 'расходов,',
  Updated1: 'обновлено',
  Updated2: ',',
  NotUpdated1: 'осталось',
  NotUpdated2: 'не обновлено.',
  NotMatchingTheCostOfTheProjectCanBeAdded: '<i class="el-icon-info" style="font-size: 16px;"></i><span style="font-size: 14px;margin-left: 5px;">Нет соответствующих статей расходов</span><b style="font-size: 16px;">Можно добавить</b>',
  ChargeWasSuccessfullyUpdated: 'Расходы успешно обновлены.',
  NotMatchingTheCostOfTheProjectCanBeUpdated: 'Нет соответствующих статей расходов для обновления.',
  NoAddedCharge: 'Расходы не добавлены.',
  DefaultValuesAreSavedSuccessfully: 'Значения по умолчанию успешно сохранены.',
  ContSigned: '(Подписано)',
  ContUnsigned: '(Не подписано)',
  InvalidCont: '(Договор аннулирован)',
  TheSystemHasBeenUpdatedPleaseRefreshThePage: 'Система обновлена, обновите страницу!',
  PleaseInputCosts: 'Введите статью расхода.',
  SelectTheSurchargeClause: 'Выберите пункт о дополнительных сборах.',
  HAWBCannotBeNull: 'Номер AMS-накладной не может быть пустым!',
  HAWBAfrCannotBeNull: 'Номер HB/L не может быть пустым!',
  HAWBCannotBeRepeated: 'Номер AMS-накладной не должен повторяться!',
  HAWBAfrCannotBeRepeated: 'Номер HB/L не должен повторяться!',
  InlandCannotBeNull: 'Внутренний пункт/склад не может быть пустым!',
  rocordNumberCannotBeNull: 'Регистрационный номер канадской таможни не может быть пустым!',
  AreYouSureYouWantToDelete1: 'Вы уверены, что хотите удалить',
  SureDeleteHbl: 'Накладную нельзя восстановить после удаления. Подтвердить удаление?',
  AreYouSureYouWantToDelete2: '?',
  PleaseSelectTheAMSNO: 'Пожалуйста, сначала выберите номер AMS',
  PleaseSelectTheHBLNO: 'Пожалуйста, сначала выберите номер HB/L',
  TheMaximumCannotExceedLines: 'Максимум не может превышать 5 строк!',
  DisplayColumn: 'Настроить отображаемые столбцы',
  Display: 'Видимый',
  Name: 'Название столбца',
  TradeCommissionedUnitCannotBeEmpty: 'Торговля: доверяющая организация не может быть пустой',
  TradeSalesSupportCannotBeEmpty: 'Торговля: поддержка продаж не может быть пустой',
  TradingCurrencyCannotBeEmpty: 'Торговля: валюта заказа не может быть пустой',
  TradingExchangeRateCannotBeEmpty: 'Торговля: курс заказа не может быть пустым',
  TradeServiceFeeDiscountRateCannotBeEmpty: 'Торговля: скидка на сервисный сбор не может быть пустой',
  TradeTheAmountOfWriteOffsCannotBeGreaterThanTheAmountOfOrders: 'Торговля: сумма списания заказа не может превышать сумму заказа',
  TradePaymentNOCannotBeEmpty: 'Торговля: номер платежа не может быть пустым',
  TradePaymentNumberCannotBeGreaterThanBitsInLength: 'Торговля: номер платежа не может превышать 16 символов',
  UnableToDeleteAllCharges: 'Нельзя удалить все расходы.',
  PleaseCheckYourNetworkOrRefreshThePage: 'Дорогой пользователь, вы находитесь в оффлайн-пространстве! Пожалуйста, проверьте подключение к интернету или обновите страницу.',
  TheFileIsSentSuccessfully: 'Файл успешно отправлен.',
  PleaseSelectAFileToDownloadOrSend: 'Пожалуйста, выберите файлы для скачивания или отправки.',
  PleaseSelectAFileSynchronization: 'Пожалуйста, выберите файлы для синхронизации.',
  PleaseSelectAFileCancelSynchronization: 'Пожалуйста, выберите файлы для отмены синхронизации.',
  FailedToModifyAFileType: 'Не удалось изменить тип файла.',
  PleaseSelectAFileType: 'Пожалуйста, выберите тип файла.',
  MBLNOCannotBeDuplicated: 'MB/L NO2 не должен повторяться!',
  PleaseSelectMBLNo: 'Пожалуйста, сначала выберите номер MBL.',
  TotalWeightOfLadingAreInconsistent: 'Несоответствие в общем количестве мест/весе/объеме коносамента!',
  TOORDERIsUnavailableToRelease: 'TO ORDER не подлежит электронной сдаче (телекс релиз)',
  TheAssociatedPrimaryFormIsNotSelected: 'Основная связанная накладная не выбрана',
  PleaseSelectHBLNo: 'Пожалуйста, сначала выберите номер HBL!',
  PleaseEnterTheBillOfLadingSerialNumber: 'Пожалуйста, сначала введите серийный номер коносамента!',
  PleaseUploadReleaseGuarantee: 'Отсутствует действующее гарантийное письмо для телекс релиза, пожалуйста, загрузите его',
  TheRecipientAddressCannotBeEmpty: 'Адрес получателя не может быть пустым.',
  OperationIsNotReversible: 'Действие необратимо.',
  Uncommitted: 'Не отправлено',
  Approved: 'Проверено',
  Submitted: 'Отправлено',
  Rejected: 'Отклонено',
  PleaseSelect: 'Пожалуйста, выберите',
  Uploaded: 'Загрузка завершена',
  Waiting: 'Ожидание загрузки',
  Uploading: 'Уже загружено',
  Other: 'Другое',
  First: 'Первая страница',
  Pre: 'Предыдущая страница',
  Page: 'Стр.',
  AllPage1: 'Всего',
  AllPage2: 'стр.',
  Next: 'Следующая страница',
  Last: 'Последняя страница',
  ShowFromTo1: 'Показать',
  ShowFromTo2: 'до',
  AllRecord1: 'всего',
  Transactions: 'записей',
  AllRecord2: 'запись',
  Convert: 'эквивалент',
  YouAreUnableToUseThisFunctionAsWHHasntBeenConfiguredIfNeedPleaseContactCSOnline: 'Уважаемый клиент, у вас не настроен склад, поэтому эта функция недоступна. Если вам это необходимо, свяжитесь с онлайн-поддержкой.',
  FirstSaveTheBusinessAutomaticLoadingIsInProgress: 'Уважаемый клиент, сначала сохраните операцию, а затем выполните автоматическое распределение товаров.',
  FirstSaveTheBusinessAddSpecialGoods: 'Уважаемый клиент, сначала сохраните операцию, а затем добавьте опасные грузы.',
  GeneralTrade: 'обычная торговля',
  ProcessingWithSuppliedMaterial: 'переработка давальческого сырья',
  ProcessingTrade: 'импорт материалов для переработки',
  SamplesOfAdvertisingProductsA: 'рекламные образцы товаров категории A',
  Refuse: 'отклонить',
  Agree: 'согласиться',
  GoOn: 'продолжить',
  SubmitAudit: 'отправить на проверку руководителю',
  DataValidation: 'идет проверка данных',
  DataValidatedWithWarning1: 'Проверка данных завершена, но есть предупреждения. Продолжить?',
  DataValidatedWithWarning2: 'Нажмите "Продолжить" или "Отмена"',
  DataValidatedWithWarning3: 'Нажмите "Отмена"',
  DataValidatedSuccessfully1: 'Проверка данных успешно завершена. Подтвердить?',
  DataValidatedSuccessfully2: 'Нажмите "Подтвердить" или "Отмена"',
  DataValidatedSuccessfully3: 'Нажмите "Отмена"',
  DataValidatedFailure1: 'Проверка данных не пройдена. Обработайте непрошедшие проверку данные и повторите попытку.',
  DataValidatedFailure2: 'Ошибка проверки данных 2',
  WoChat: 'ВоЛайк (WoChat)',
  TheSystemHasBeenUpdatedPleaseTurnTheModuleOnAgain: 'Система обновлена. Закройте модуль и откройте его снова.',
  TheSystemHasBeenUpdatedPleaseReLoginOrClearBrowserCache: 'Система обновлена. Войдите снова или очистите кеш браузера.',
  AddAdjustment: 'добавить корректировку',
  AddCharge: 'добавить расходы',
  AddCostCharge: 'добавить дебиторскую задолженность',
  AddPayCharge: 'добавить кредиторскую задолженность',
  EditAdjustment: 'изменить корректировку',
  EditCharge: 'изменить расходы',
  EditCostCharge: 'изменить дебиторскую задолженность',
  EditPayCharge: 'изменить кредиторскую задолженность',
  DeleteAdjustment: 'удалить корректировку',
  DeleteCostCharge: 'удалить дебиторскую задолженность',
  DeletePayCharge: 'удалить кредиторскую задолженность',
  DateOfAdjustmentCannotBeNull: 'Дата корректировки не может быть пустой.',
  CurrencyOfAdjustmentCannotBeNull: 'Валюта не может быть пустой.',
  AmountCannotBeZero: 'Количество не может быть нулевым.',
  UnitPriceCannotBeZero: 'Цена за единицу не может быть нулевой.',
  AmountCannotBeZero2: 'Сумма не может быть нулевой.',
  ExchangeCannotBeZero2: 'Курс обмена не может быть нулевым.',
  RemarkTheLengthCannotExceed: 'Длина примечания не должна превышать 50 символов.',
  InvoiceNoCannotBeNull: 'Налоговый номер не может быть пустым.',
  InvoiceNoIsTooLong: 'Налоговый номер слишком длинный.',
  PleaseAddSpecialGoodsFirst: 'Сначала добавьте опасные грузы.',
  UNNoIsEmpty: 'Укажите номер ООН.',
  LoadSpGoodsContainerError: 'Ошибка загрузки информации об упаковке опасных грузов.',
  AssociatedSpGoodsError: 'Ошибка в связанной информации об опасных грузах',
  NoAssociatedInfo: 'Нет связанной информации',
  InnerPackagingTypeIsRequired: 'Тип внутренней упаковки обязателен для заполнения',
  InnerPackagingQuantityIsRequired: 'Количество внутренней упаковки обязательно для заполнения',
  SeaPollutionOnlyEnterYN: 'Значение поля "Загрязнение моря" должно быть Y или N',
  SelectHsCode: 'Выберите код HS',
  SelectCargoChineseName: 'Выберите название товара на китайском',
  DispatchNotYet: 'Заказ не был успешно распределен, изменение заказа на машину запрещено',
  AllDataMustBeOperating: 'Все данные должны быть в статусе "Активные"',
  TheSelectedDocumentInconsistentNatureOfTheContainerLoadType: 'Выберите услуги с одинаковым типом консолидации',
  TheNumberOfChargesLimited: 'Максимальное количество расходов не может превышать',
  TheNumberOfSelectedDataLimited: 'Выбранные данные не могут превышать',
  PleaseInputSearchCondition: 'Введите условия поиска',
  PlaceOfDeliveryCannotBeNull: 'Место доставки не может быть пустым',
  ImportSuccessChargesCount: 'Успешно импортировано {count} расходов',
  CheckChargeDetailBranch: 'Филиал, к которому относятся активные данные, не принадлежит текущему или вышестоящему филиалу',
  ChangeSelectSales: 'Продолжить сохранение при изменении продаж?',
  NoSelectedCargoDocInformation: 'Выберите одну запись коносамента!',
  OverseaCostChargeEmpty: 'Дебиторская задолженность пуста!',
  OverseasBillsCanNotBePrinted: 'Невозможно распечатать зарубежный счет (счет пуст, не выбран, аннулирован, нет прав)!',
  CheckHBLReleaseStateBeforePrint: 'Не является разрешенным для выпуска, печать невозможна!',
  NoSelectedWarehouseInInformation: 'Не выбрана складская информация для печати!',
  NoWarehouseInInformation: 'Выбранная вами складская информация неверна!',
  ConfirmTheShutOut: 'Вы уверены, что хотите аннулировать эту операцию? Все расходы будут удалены!',
  SaveSucceed: 'Сохранено успешно!',
  SelectOneJob: 'Разрешено выбирать только одну операцию для копирования!',
  PleaseInputETD: 'Выберите диапазон дат отправления!',
  SelectJob: 'Выберите услугу!',
  DateToday: 'Сегодня',
  PleaseSelectSoNo: 'Выберите номер таможенной декларации',
  ChargeOffsetState: 'Расходы уже сторнированы или были сторнированы',
  isDeleteAllEDIContainer: 'Очистить всю информацию об упаковке?',
  ServiceCodeCannotBeNull: 'Код услуги не может быть пустым',
  Choose: 'Выбрано',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeForceDel: 'Этот счет уже отправлен на финансовую проверку, его нельзя удалить принудительно.',
  ThisVerificationHasBeenDoneAndCannotBeForceDel: 'Эта операция уже была погашена, ее нельзя удалить принудительно.',
  ThisFormIsLockedAndCannotBeForceDel: 'Эта операция заблокирована, ее нельзя удалить принудительно.',
  ConfirmTheForceDelOfTheBill: 'Подтверждаете принудительное удаление этого счета?',
  ForceDelSuccessfully: 'Принудительное удаление успешно',
  IsNotOperationStatusCannotBeShutOut: 'Массовый отказ от таможенного оформления возможен только для операций в статусе "Активные"',
  IsNotOperationStatusCannotBeCancellation: 'Массовая аннуляция возможна только для операций в статусе "Активные"',
  ManifestLink: 'Ссылка на манифест ниже',
  ApplicationAmountCheck: 'Сумма заявки на оплату не соответствует общей сумме в списке расходов, проверьте!',
  TipsOnSplittingExpenses: 'Сумма разделенных расходов не может превышать исходную сумму, измените сумму разделенных расходов!',
  DcCopyCheck: 'У этой операции есть сотрудник по документам без информации о отделе или компании, выберите заново!',
  CsrCopyCheck: 'У этой операции есть сотрудник службы поддержки без информации о отделе или компании, выберите заново!',
  SureDeleteThese: 'Вы уверены, что хотите удалить эту',
  OrdersOfBusiness: 'операцию?',
  SureCancellationAndDeleteCharge: 'Вы уверены, что хотите аннулировать операцию? Все расходы будут удалены!',
  SureShutOutAndDeleteCharge: 'Вы уверены, что хотите отказаться от таможенного оформления? Все расходы будут удалены!',
  CheckingConsignation: 'Эту операцию нельзя делегировать, проверьте и повторите попытку!',
  TheSubBillHasBeenConsolidatedAndCannotBeDelete: 'Эта накладная уже скомплектована, удаление невозможно.',
  SaveFailedMessage: 'Сохранение не удалось, обновите и повторите попытку!',
  SettlementAgentCannotBeNull: 'Расчетный агент не может быть пустым!',
  SettlementAgentErrorPleaseReSelect: 'Ошибка расчетного агента, выберите заново!',
  NowContainer: 'Текущий контейнер',
  NowContainerCanNotDelete: 'Текущий контейнер занят, удаление невозможно!',
  NotDelete: 'Удаление невозможно!',
  PleaseSelectBoxType: 'Выберите тип контейнера!',
  PleaseEnterUnitPrice: 'Введите цену за единицу!',
  PleaseSelectCurrency: 'Выберите валюту!',
  PleaseEnterTheStartDate: 'Введите дату начала аренды!',
  PleaseEnterThebuyDate: 'Введите дату покупки контейнера!',
  PleaseEnterEndDate: 'Введите дату окончания!',
  SuccessfulBoxAdjustment: 'Перемещение контейнеров успешно! Обработано количество',
  NoBoxesProcessedSuccessfully: 'Нет успешно обработанных контейнеров, проверьте фактическую загрузку!',
  OnlyBuyCaseOrderBoxCanBeSold: 'Можно продавать только контейнеры из заказов на покупку, проверьте!',
  ChoiceCaseSell: 'Выберите контейнеры с одинаковой валютой для продажи!',
  PleaseContainerData: 'Введите информацию о контейнере!',
  UnifiedCurrency: 'Заказы на продажу контейнеров поддерживают только одну валюту, унифицируйте валюту продажи!',
  PleaseCheckTheBoxToBeSold: 'Отметьте контейнеры для продажи!',
  EditedFailMessage: 'Изменение не удалось, обновите и повторите попытку!',
  DataValidatedWithPartialPass1: 'Проверка данных завершена, но есть предупреждения и ошибки, продолжить?',
  DataValidatedWithPartialPass2: 'Нажмите 【Продолжить】, отмена',
  DataValidatedWithPartialPass3: 'Нажмите 【Отмена】 Примечание: для непройденных проверок данных обработайте их перед повторной попыткой',
  AddChangeCharge: 'Добавить расходы на изменение заказа',
  ThereAreNoPayableBillsToPrint: 'Нет доступных для оплаты документов для печати.',
  ReleaseInformationNotSelected: 'Информация о выпуске документов не выбрана',
  AreYouSureYouWantTo: 'Вы уверены, что хотите {0}?',
  NoRecordsAvailable: 'Нет записей для {0}.',
  NoDataToAudit: 'Нет данных для проверки.',
  NoSplittingRecordSelected: 'Не выбраны записи разделения заказа.',
  NoDataToAudit2: 'Нет данных для {0}.',
  EditChangeCharge: 'Изменить расходы на изменение заказа',
  AddSpecialCharge: 'Добавить специальные расходы',
  EditSpecialCharge: 'Изменить специальные расходы',
  AddSpecialUpdate: 'Корректировка специальных расходов',
  Pstsftba: 'Выберите специальные расходы для корректировки!',
  Nsecbe: 'Нельзя редактировать неспециальные расходы!',
  UpdateWarehouseRecord: 'Склад был изменен, продолжить сохранение?',
  CheckCostAndBusinessMismatching: 'Выбранные статьи расходов не соответствуют операции',
  TicketEntrustedCannotRepetitionDelegate: 'Эта накладная уже делегирована, не дублируйте!',
  NotFindCurrencyRatePleaseMaintain: 'Не найден курс валюты {0}, обновите соответствующий курс перед сохранением!',
  BillPaymentDeleteTips: 'Можно удалять только платежные заявки, не прошедшие финансовое одобрение и не погашенные',
  SettlementAgentNotNull: 'Расчетный агент не может быть пустым!',
  PleaseSelectSameSettlementAgent: 'Выберите счета с одинаковым расчетным агентом!',
  TheHAWBAndMAWBAreInconsistentTheSystemWillModifyTheHAWBContinue: '新选小票目的港代理,装货港,目的港,订舱代理,航空公司,航班,ETD,订舱性质,主单运费条款\n与主票不一致，系统将修改小票,是否继续？',
  AMS_ReturnMessage: 'AMS提箱件毛体信息与实际不符,请调整！\n',
  AMS_ReturnMessageCanSave: 'AMS提箱件毛体信息与实际不符，是否继续保存？\n',
  AMS_Quantity: '【AMS件数{0} {1} 实际件数{2}】\n',
  AMS_Weight: '【AMS毛重{0} {1} 实际毛重{2}】\n',
  AMS_Cubage: '【AMS体积{0} {1} 实际体积{2}】\n',
  AMS_ContainerNo: '箱号【{0}】：\n',
  CheckPortsByConsignation: 'Ваш доверитель 【{0}】 не обслуживает порт 【{1}】, пожалуйста, согласуйте с контрагентом перед отправкой поручения!',
  CheckPackingByConsignation: 'Ваш доверитель 【{0}】 не поддерживает упаковку 【{1}】, пожалуйста, согласуйте с контрагентом перед отправкой поручения!',
  CheckCompanyByConsignation: 'Ваш доверитель 【{0}】 не имеет информации о коде SCAC 【{1}】 и других данных, пожалуйста, согласуйте с контрагентом перед отправкой поручения!',
  CheckCarrier: 'Сначала зарегистрируйте код SCAC для 【{0}】, затем отправляйте поручение!',
  SettleAccountMustBeSame: 'Объекты расчета должны совпадать',
  ReceivableCannotMorethanPay: 'Начисленные расходы не могут превышать подлежащие оплате',
  PleaseSelectJobs: 'Выберите запись операционного документа',
  SapCommitCheck: 'Разовая подача документов в SAP завершена, не повторяйте отправку',
  SapCancelCommitCheck: 'Невозможно отозвать статус расходов в SAP, проверьте статус расходов в SAP',
  escnm: 'Подразделение для расчета расходов не зарегистрировано',
  SapSynchronizationSuccess: 'Синхронизация расходов с SAP успешно завершена',
  SapSynchronizationFault: 'Ошибка синхронизации расходов с SAP',
  SapStatusCanNotAudit: 'Невозможно проверить статус расходов в SAP, подтвердите статус расходов в SAP',
  ChangeOrderSubmissionFailed: 'Ошибка подачи изменений: не обнаружены расходы, требующие корректировки!',
  SureYouWantToDeleteFilesTwo: 'Вы уверены, что хотите массово удалить эти {0} файлов?',
  JumpFailed: 'Ошибка перенаправления',
  SelectCopyContent: 'Выберите содержимое для копирования',
  CopyContent: 'Копировать содержимое',
  SelectImportContent: 'Выберите содержимое для импорта',
  ImportContent: 'Импортировать содержимое',
  DifferenceOverwritesTheOriginalValue: 'Перезаписать исходные значения различающихся полей',
  DifferenceRetainsTheOriginalValue: 'Сохранить исходные значения различающихся полей',
  RememberToChoose: 'Запомнить мой выбор',
  TheImportedServiceNumberDoesNotExistProcedure: 'Ошибка импорта: указанный номер операции не существует, повторите попытку!',
  TheIDOfTheImportedServiceMustBeDifferentFromThatOfTheImportedService: 'Номера операций импорта и экспорта не должны совпадать',
  CopyNumber: 'Количество копий в этой операции',
  QuickSearchBusinessNo: 'Быстрый поиск: номер операции',
  QuickSearchChineseName: 'Быстрый поиск: китайское имя',
  FinancialDateOfASingleExpense: 'Вы уверены, что хотите изменить финансовую дату для отдельного расхода?',
  ExpenseFinancialDateModifiedSuccessfully: 'Финансовая дата расхода успешно изменена',
  ModifyTheFinancialDate: 'Вы уверены, что хотите изменить финансовую дату?',
  FinancialDateModifiedSuccessfully: 'Финансовая дата успешно изменена',
  ApprovalDateIsEarlierThanBusinessDate: 'Дата проверки раньше даты операции, продолжить?',
  AreYouSureToReviewTheseLists: 'Вы уверены, что хотите проверить эти документы?',
  ThisBusinessIsNotApproved: 'Эта операция не в статусе [{0}], проверка запрещена, проверьте!',
  ThisBusinessIsNotApproved2: 'Эта операция не в статусе [{0}], отзыв запрещен, проверьте!',
  TheDocumentChangeSubmission: 'Вы уверены, что хотите отозвать подачу изменений?',
  AllowOrderChange: 'Вы уверены, что хотите разрешить внесение изменений?',
  AllowToChangeTheOrderSuccessfully: 'Разрешение на внесение изменений успешно предоставлено',
  NoExpenseSelectedOrNotInApprovalStatus: 'Расходы не выбраны или не находятся в статусе проверки',
  ExpenseStatusUpdatedSuccessfully: 'Статус расходов успешно обновлен',
  BusinessHasGeneratedVouchers: 'По операции сформирован документ,',
  UnableCancelAudit: 'Невозможно отменить проверку.',
  BusinessNumberWithGeneratedVouchers: 'Номера операций с сформированными документами:',
  AreYouSureYouWantToCancelTheApproval: 'Вы уверены, что хотите отменить проверку?',
  LCLTicketsCannotBeReviewedSeparately: 'Накладные сборных грузов нельзя проверять отдельно, проверьте основную накладную.',
  ItIsLocked: 'Заблокировано для печати, обратитесь к руководителю для разблокировки!',
  PleaseSelectTheBusiness: 'Выберите операции, для которых нужно изменить дату',
  BusinessDateModifiedSuccessfully: 'Дата операции успешно изменена',
  BatchApprovalFailed: 'Массовая проверка не удалась',
  PleaseSelectTheBusinessToPrint: 'Выберите операции для печати',
  NoInTheSelectedData: 'В выбранных данных есть операции не в статусе [{0}], проверка невозможна. Проверьте данные!',
  TheApprovalDateIsEarlierThanTheBusinessDate: 'Дата проверки раньше даты операции. Продолжить?',
  FailedToGetDetails: 'Не удалось получить детали',
  PleaseEnterTheBoxSealNumber: 'Введите номер контейнера/пломбы перед печатью анализа прибыли',
  AfterPrintingTheProfitAnalysisStatement: 'После печати анализа прибыли операция будет отправлена на финансовую проверку без возможности изменений. Продолжить?',
  PleaseEnterTheApprovalDate: 'Введите дату проверки',
  PleaseSelectARecordToView: 'Выберите запись для просмотра',
  ContractExpireCannotCreated: 'Договор с данным принципалом истек, создание операций невозможно',
  CheckBusinessStatus: 'Ошибка операции. Проверьте статус соответствующей операции',
  CheckCustomsSaved: 'Сначала сохраните декларацию, затем загрузите документы!',
  SelectCustomsBroker: 'Выберите таможенного брокера',
  SelectCustomsBrokerPlatFormProvider: 'Вы не настроили "поставщика платформы" для выбранного брокера в партнерах, отправка невозможна',
  SelectCustomsSonoLobFiles: 'Номер декларации, брокер, документы и тип операции обязательны. Проверьте данные',
  VesselAndvVoyageFlightisEmpty: 'Название судна/рейс не указаны. Подтверждаете отправку?',
  customsInfoIsAlredySend: 'Эта декларация уже отправлена (поддерживается однократная отправка). Для изменений свяжитесь с брокером',
  DocumentEditedTips: 'Вы не ответственный за эту операцию, редактирование невозможно',
  CustomerTipMessage: '[{0}] не является принципалом. Выберите заново!',
  PortOfLoadingPortCannotBeNull: 'Порт погрузки обязателен',
  PromissoryNoteIsAFormalBusiness: 'Эта операция уже официальная!',
  CannotBeConvertedToFormalBusinessInBatch: 'Содержит операции с источником "внутренние операции арендатора", массовый перевод в официальные невозможен',
  whetherToTransferSmallTicketToFormalBusinessAtTheSameTime: 'Перевести сопутствующие операции в официальные одновременно?',
  transferSmallTicketToFormalJobAtTheSameTime: 'Сопутствующие → официальные',
  onlyTheMasterTicketIsTransferredToFormalJob: 'Только основную → официальную',
  pleaseTransferTheCorrespondingMasterTicketToFormalJobFirst: 'Сначала переведите основную операцию в официальную!',
  BusinessCannotBeOperatedTogether: 'Обычные и делегированные операции нельзя обрабатывать вместе. Выберите заново!',
  PleaseEnterTheWarehouseNumber: 'Быстрый поиск: № склада',
  BookingSeal: 'Штамп бронирования',
  CheckSplitCharges: 'Расходы уже разделены. Сначала удалите разделенные',
  mutualChargeSynchronizationSuccess: 'Синхронизация перекрестных расходов успешна!',
  mutualChargeSynchronizationFault: 'Синхронизация перекрестных расходов не удалась!',
  confirmQuit: 'Подтверждаете выход?',
  SelectMBL: 'Коносамент (вкладка брони - MB/L NO) обязателен',
  SelectMBLSI: 'Главный № (импорт - главный №) обязателен',
  SelectMBLAE: 'Главный № (основное - главный №) обязателен',
  SelectMBLAI: 'Главный № (авиа - главный №) обязателен',
  SelectLob: 'Выберите тип операции',
  SelectPreCustomsDate: 'Выберите предварительную дату таможни',
  SelectHarborDistrictSe: 'Порт (вкладка брони - порт) обязателен',
  SelectHarborDistrictSi: 'Порт (импорт - порт) обязателен',
  DestinationPlaceNotNull: 'Место доставки (импорт - место доставки) обязательно!',
  AirportPortNotNull: 'Аэропорт обязателен',
  ExpectedDateOfArrivalNotNull: 'Ожидаемая дата прибытия (импорт - дата прибытия) обязательна!',
  SelectCustomsFiles: 'Выберите таможенные документы',
  CustomsHasBeanSend: 'Эта декларация уже отправлена (поддерживается однократная отправка). Для изменений свяжитесь с брокером',
  FileSizeExceeds4MBYouCannotUploadPleaseSendEmailSe: 'Файл не должен превышать 20Мб. Отправьте по почте на xh08@thecustoms.com.cn',
  PleaseUploadFileSeaExport: 'Загрузите: доверенность брокеру, информацию о размещении, черновик экспортной декларации с элементами декларирования, инвойс, упаковочный лист',
  PleaseUploadFileSeaImport: 'Загрузите: доверенность брокеру, коносамент FCL, информацию/копию delivery order, инвойс, упаковочный лист, контракт, сертификат происхождения, элементы декларирования',
  PleaseUploadFileAirExport: 'Пожалуйста, загрузите следующие документы: доверенность на таможенное оформление, транспортную накладную, черновик экспортной декларации и другие.',
  PleaseUploadFileAirImport: 'Пожалуйста, загрузите следующие документы: доверенность на таможенное оформление, уведомление о прибытии груза, авианакладную, инвойс, упаковочный лист, контракт, сертификат происхождения, декларационные элементы товара и другие.',
  SuccessfulCustoms: 'Таможенное оформление успешно завершено!',
  FaildCustoms: 'Ошибка запроса таможенного оформления, пожалуйста, свяжитесь с администратором!',
  AsyncReceivableChargesToImportJob: 'Все подлежащие получению расходы будут синхронизированы с импортными операциями. Подтверждаете продолжение?',
  AsyncPayableChargesToImportJob: 'Все подлежащие оплате расходы будут синхронизированы с импортными операциями. Подтверждаете продолжение?',
  escnm2: 'Отдел расчетов по расходам не может быть пустым.',
  SelectMoreTwoRow: 'Пожалуйста, выберите как минимум две записи для объединения!',
  OnlySplitMasterJob: 'Можно разделить только главную накладную!',
  SplitJobTip: 'Пожалуйста, выберите главную накладную с типом консолидации Buyer Console FCL и статусом операции "Активная" для разделения!',
  CombinationJobSelectMasterTip: 'Вы уверены, что хотите объединить следующие операции? Пожалуйста, выберите одного ответственного в качестве главной накладной.',
  CombinationJobForFcl: 'Тип консолидации: FCL (полный контейнер) и Buyer Console FCL.',
  CombinationJobForJobState: 'Статус операции: "Активная".',
  CombinationJobForCustomer: 'Единый принципал.',
  CombinationJobForVessel: 'Название судна совпадает.',
  CombinationJobForVesselVoyage: 'Рейс совпадает.',
  CombinationJobForMaster: 'Пожалуйста, выберите главную накладную!',
  CombinationJobTip: 'Пожалуйста, выберите операцию {0} для выполнения действий!',
  ValidateCombinationJobTip: 'Операция с номером коносамента {0} уже используется. Нажмите "Отмена" и повторите объединение!',
  OnlyJoinForCombinationJob: 'Разрешено добавлять только операции с типом консолидации FCL и Buyer Console FCL!',
  TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue: 'Реквизиты для выставления счета не совпадают. Продолжить?',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue2: 'Название судна, рейс, перевозчик, агент по бронированию, агент в порту назначения, ETD, ETA, информация о складе, номер соглашения судоходной компании в новой выбранной частичной накладной не совпадают с главной накладной. Система изменит частичную накладную. Продолжить?',
  HblNoMoreThanTwelve: 'Номер частичной накладной не может превышать 12 символов!',
  WriteOffPushSuccess: 'Запись о зачете успешно отправлена!',
  WriteOffPushError: 'Ошибка отправки записи о зачете!',
  CancelConfirmBill: 'Синхронизировать отмену подтверждения расходов?',
  AreYouSureYouWantToDeleteTheSelectedFee: 'Подтверждаете удаление выбранных расходов?',
  JobOfClosingAccountTip: 'Невозможно сохранить дату операции. Пожалуйста, скорректируйте и сохраните!',
  ThePacketHasBeenSentAndWhetherToImportItAgain: 'Сообщение уже отправлено. Импортировать снова?',
  PleaseCheckAtLeastOnePieceOfData: 'Пожалуйста, выберите хотя бы одну запись.',
  NoHasViewRole: 'Без прав просмотра, пожалуйста, свяжитесь с администратором для настройки!',
  NoHasViewBillingRole: 'Нет прав на просмотр счетов. Обратитесь к администратору для настройки!',
  NoHasViewBillingGroupRole: 'Нет прав на просмотр выписок. Обратитесь к администратору для настройки!',
  checkSpecialChargeTips: 'Записи о списании, содержащие специальные расходы, не могут быть использованы для создания документа. Пожалуйста, выберите заново!',
  CheckCustomJobTypeTips: 'Пожалуйста, выберите пользовательский тип операции перед сохранением!',
  AMSCodeCannotBeNull: 'Базовая конфигурация AMSCompanyCode не может быть пустой!',
  MblNoIsOverLength: 'Поле [MB/L NO] превышает 16 символов.',
  AmsNoIsOverLength: 'Поле [AMS NO] превышает 12 символов.',
  IsOverLengthTip: 'Поле {0} слишком длинное. Пожалуйста, не превышайте {1} символов в каждой строке данных.',
  UnitTypeNotNull: 'Тип единицы (Unit Type) не может быть пустым. Пожалуйста, укажите.',
  Shipper: 'Грузоотправитель',
  Consignee: 'Грузополучатель',
  Notify: 'Уведомляемая сторона',
  SecondNotify: 'Вторая уведомляемая сторона',
  SpecialCharacter: 'Поле {0} содержит недопустимые символы и не может быть сохранено!',
  TipsOnAutoSplittingCharge: 'Пожалуйста, введите верхний предел цены с налогом для разделения расходов!',
  DeleteSmallTicketTips: 'У вас нет прав на удаление частичных накладных!',
  SyncToSmallTicketSuccessTips: 'Статус узла {0} синхронизирован с частичной накладной!',
  OperationTypeInUsed: 'Для {0}{1} уже есть транспортные условия {2}, отображаемые по умолчанию. Пожалуйста, выберите заново!',
  StartUpdatingTheBasicData: 'Начато обновление базовых данных.',
  BasicDataUpdateSuccessfully: 'Базовые данные успешно обновлены.',
  BatchSubmitCheck: 'Можно отправлять только пакетные заявки с положительными операциями или предварительно отправленные!',
  isExistHBLANDMBLTips: 'Номера подзаявок под одним основным номером не должны повторяться, пожалуйста, введите номер подзаявки заново!',
  operateTypeUpdateTips: 'Изменен режим операции, обновить информацию о MAWB?',
  SettlingAgentInconsistent: 'Расчетный агент не совпадает, продолжить?',
  SettlingAgentInvoiceTitleInconsistent: 'Расчетный агент и реквизиты счета не совпадают, продолжить?',
  ChargeEmpty: 'Расходы не указаны!',
  NoChargeForTheSettlementOfPrint: 'Нет объектов расчета расходов, соответствующих условиям печати.',
  PleaseEnterTheCreationDate: 'Пожалуйста, введите дату создания.',
  SelectDate: 'Выберите дату',
  DefaultCurrency: 'Валюта по умолчанию',
  EDISUBMISSIONCenter: 'Центр отправки EDI',
  EDICenter: 'Центр EDI',
  MessagePreview: 'Предпросмотр сообщения',
  MessageDesign: 'Дизайн сообщения',
  ReceiverCodeCannotBeEmpty: 'Код получателя не может быть пустым',
  SelectEDIType: 'Выберите тип EDI',
  NotConfigured: 'Не настроено',
  SelectSendingChannel: 'Выберите канал отправки',
  SelectFileNature: 'Выберите тип файла',
  SelectFileTemplate: 'Выберите шаблон файла',
  SelectedBusiness: 'Выбранные операции:',
  BackToEDICenter: 'Вернуться в центр EDI',
  Design: 'Дизайн',
  SendAll: 'Отправить все',
  Tips: 'Подсказка:',
  UsedInTemplateDesign: 'Используется в дизайне шаблона',
  Check: 'Проверить',
  SentSuccessfully: 'Отправлено успешно!!',
  TemplateSavedSuccessfully: 'Шаблон успешно сохранен',
  OtherDocuments: 'Другие файлы',
  ClickUpload: 'Нажмите для загрузки',
  UnsupportedFileType: 'Неподдерживаемый тип файла',
  TheSizeExceedsTheLimit: 'Размер файла превышает ограничение',
  UploadFailed2: 'Ошибка загрузки',
  PleaseSelectABusinessNumber: 'Пожалуйста, выберите номер операции',
  TheExceeds20MBAndUploaded: 'Размер одного файла превышает 20 МБ, загрузка невозможна.',
  UploadPleaseContactTheAdministrator: 'Ошибка загрузки, пожалуйста, свяжитесь с администратором.',
  FailedPleaseRefreshAndAgain: 'Не удалось получить данные, обновите и попробуйте снова',
  ExternalImportedDataNonEditable: 'Данные импортированы извне, редактирование невозможно',
  ExternalDataCannotBeDeleted: 'Данные импортированы извне, удаление невозможно.',
  RequestSucceededExporting: 'Запрос выполнен успешно, идет экспорт!',
  Main: 'Основное',
  PleaseEnterTheWarehousingNumber: 'Пожалуйста, введите номер склада!',
  PleaseEnterTheWarehouseName: 'Пожалуйста, введите название склада!',
  PleaseEnterTheWarehouseInDate: 'Пожалуйста, выберите время поступления на склад!',
  PleaseMaintainWeighDetail: 'Пожалуйста, сначала заполните детали взвешивания (фактические) груза!',
  PleaseEnterComments: 'Результат проверки заявки не пройден, пожалуйста, заполните рекомендации по обработке!',
  PleaseSelectTheClosingWeight: 'Пожалуйста, выберите вес таможенного пломбирования!',
  SureToSaveLabeling: 'Взвешивание еще не проведено, подтвердите сохранение информации о маркировке?',
  PleaseLengthWidthPieces: 'Пожалуйста, введите размеры в правильном формате: длина*ширина*высота*количество!',
  PleaseTheNumberOfPieces: 'Введите количество мест!',
  WarehouseNumberAlreadyExistsContinue: 'Номер склада уже существует, продолжить?',
  SavedSuccessfully: 'Сохранено успешно!',
  ChecklistSuccessfully: 'Статус проверки успешно обновлен!',
  NoSynchronizationContent: 'Нет данных для синхронизации',
  ThereSynchronizationSpecialGoodsSynchronize: 'В информации о упаковке есть контейнеры, связанные с особыми грузами. После синхронизации особые грузы нужно будет связать заново. Подтверждаете синхронизацию?',
  SynchronizationSucceeded: 'Синхронизация прошла успешно',
  SynchronizationFail: 'Ошибка синхронизации',
  ThisJobIsNotWorkingCanNotBeEdited2: 'Указанная операция не в активном состоянии, синхронизация невозможна',
  ASameBoxTypeExists: 'Уже существует запись с таким же типом и видом контейнера!',
  IfToRefreshTheContainers: 'Количество контейнеров изменилось, обновить расходы, рассчитанные по количеству контейнеров?',
  BusinessCannotBeEmpty: 'Операция не может быть пустой!',
  ViewChargebackFile: 'Просмотреть файл возврата',
  SelectDepartment: 'Выберите отдел',
  PleaseSelectADepartment: 'Пожалуйста, выберите отдел!',
  ReceiptSucceeded: 'Квитанция успешно получена',
  ReceiptError: 'Ошибка получения квитанции',
  SubmittedForDeletion: 'Изменения отправлены',
  ModificationFailed: 'Не удалось изменить',
  EDIStatusChangeRecord: 'Журнал изменений статуса EDI',
  FeedbackNode: 'Узел обратной связи',
  YouTheLinkAddressDirectly: 'Просто скопируйте адрес ссылки для сверки',
  HistoricalAnomaly: 'История аномалий',
  TimeOfOccurrence: 'Время возникновения',
  VerificationOfEstimatedProfitMargin: 'Проверка расчетной рентабельности',
  EstimatedIncome: 'Расчетный доход',
  EquivalentToRMB: 'Эквивалент в юанях',
  EstimatedCost: 'Расчетные затраты',
  EstimatedProfit: 'Расчетная прибыль:',
  EstimatedProfitMargin: 'Расчетная рентабельность:',
  EstimatedRemarks: 'Примечание к расчету:',
  EstimatedMustBeFilledIn: 'Примечание к расчету обязательно для заполнения.',
  Sunday: 'Воскресенье',
  Monday: 'Понедельник',
  Tuesday: 'Вторник',
  Wednesday: 'Среда',
  Thursday: 'Четверг',
  Friday: 'Пятница',
  Saturday: 'Суббота',
  SelectFileType: 'Выберите тип файла',
  FileInformation: 'Информация о файле',
  Thumbnail: 'Миниатюра',
  DownloadPhotos: 'Скачать фото',
  UploadComplete: 'Загрузка завершена!',
  UploadFailedSigh: 'Ошибка загрузки!',
  HelloNNPleaseCheck: 'Здравствуйте,\n\nПожалуйста, ознакомьтесь',
  WarehousingNo: 'Номер склада -',
  WarehousingNoColon: 'Номер склада:',
  PhotosNthankYouN: 'Фотографии\n\nСпасибо.\n\n',
  SendingSucceeded: 'Отправлено успешно!',
  SendingFailed: 'Ошибка отправки!',
  PleaseTheFileToDownload: 'Пожалуйста, выберите файл для скачивания.',
  WaybillNo: 'Номер накладной:',
  ConfirmSending: 'Подтвердить отправку',
  ReturnToModify: 'Вернуться к редактированию',
  ChannelName: 'Название канала',
  PleaseSelectASendingChannel: 'Пожалуйста, выберите канал отправки!',
  FailedToGetTemplate: 'Не удалось получить шаблон',
  TheDocumentOfTheContinue: 'Название нового небольшого билета рейс, судоходная компания, номер основного листа, сменный агент, дата отправления, ожидаемая дата прибытия в порт, фактическая дата прибытия, склад, основной способ выпуска и условия фрахта основного листа не совпадают с основным билетом; Или небольшой билет таможня имеет номер пустой.\r\nСистема изменит небольшие билеты. Продолжение?',
  PleaseSelectACodingRule: 'Пожалуйста, выберите правило кодирования.',
  ApplicationForRelease: 'Запрос на размещение в трюме',
  ApplyForShipperCode: 'Запрос SHIPPER CODE',
  NoDataSelected: 'Данные не выбраны!',
  InvalidFee: 'Недействительная плата!',
  ReceivingMethod: 'Способ получения:',
  CellPhoneNumber: 'Номер телефона:',
  NoteDoesNotAffectPartner: 'Примечание: изменения на этой странице не влияют на исходную конфигурацию партнера.',
  emptySopNodeWarning: 'Если узел推送 пуст, сообщение не будет отправлено корректно.',
  AsynchronousLocking: 'Фоновая система выполняет асинхронную блокировку заказа, результат можно проверить позже в правом верхнем углу (сообщения).',
  AsynchronousJobAccountVerify: 'Фоновая система выполняет асинхронную обработку, результат можно проверить позже в правом верхнем углу (сообщения).',
  RepeatClick: 'Фоновая система выполняет блокировку заказа, пожалуйста, не нажимайте повторно.',
  RepeatClickJobAccountVerify: 'Фоновая система выполняет проверку, пожалуйста, не нажимайте повторно.',
  RepeatClickJobAccountVerify2: 'Фоновая система выполняет отмену проверки, пожалуйста, не нажимайте повторно.',
  AddFromPartner: 'Добавить от партнера',
  AddManually: 'Ручное добавление',
  ReceivingMode: 'Способ получения',
  PushNodeCannotBeEmpty: 'Узел推送 не может быть пустым!',
  PushBeEmptyPleaseCheck: 'Узел推送 не может быть пустым, пожалуйста, проверьте:',
  DetailedNumberOfCheckedGoods: 'Количество отмеченных товаров',
  NumberAssociatedPackingInformationPieces: 'Количество связанной упаковочной информации',
  DetailedWeightOfGoodsChecked: 'Вес отмеченных товаров',
  AssociatedPackingInformationWeight: 'Вес связанной упаковочной информации',
  DetailedVolumeOfGoodsChecked: 'Объем отмеченных товаров',
  AssociatedPackingInformationVolume: 'Объем связанной упаковочной информации',
  CopyShippingMarkAndName: 'Копировать с маркировки и наименования товара доверителя',
  OperationCategory: 'Тип операции',
  PleaseEnterTheBusinessNumber: 'Пожалуйста, введите номер операции.',
  NonExistent: 'Не существует.',
  ContainerTip: 'Этот контейнер уже связан с оплатой, пожалуйста, сначала разорвите связь, а затем измените номер контейнера.',
  UploadCustomsDeclarationFile: 'Загрузить таможенные документы',
  UploadChargebackFile: 'Загрузить документы на возврат',
  RevenueTypeCannotBeBlank: 'Тип дохода/расхода не может быть пустым!',
  SettlementCompanyCannotBeBlank: 'Расчетная единица не может быть пустой!',
  IncorrectFormatOnlyIntegerSupported: 'Формат данных налога неверен, поддерживаются только целые числа!',
  domesticForeignCannotBeEmpty: 'Внутренний/внешний не может быть пустым!',
  ImportResults: 'Результат импорта',
  AllSuccess: 'Все успешно',
  AllFailed: 'Все неудачно',
  PartialFailurePartialSuccess: 'Частично неудачно, частично успешно',
  OddNumbers: 'Номер документа',
  PleaseTheSameBusinessOperate: 'Пожалуйста, выберите операции одного типа бизнеса!',
  OperationError: 'Ошибка операции',
  NewBusiness: 'Новый бизнес',
  ThePleaseRefreshAndAgain: 'Система перегружена, обновите и повторите попытку',
  SubmittersRemarks: 'Примечание отправителя',
  PleaseFillInTheRemarks: 'Пожалуйста, заполните примечание',
  YouAreNotTheSubmitter: 'Не являетесь руководителем отправителя? Невозможно выполнить операцию!',
  PleaseFillInTheRemarksSigh: 'Пожалуйста, укажите примечание!',
  PleaseEnterRemarks: 'Введите примечание!',
  TheTheCurrentOperationMaintenance: 'Руководитель не назначен. Назначьте и повторите отправку!',
  FailedForApprovalPleaseAgain: 'Ошибка отправки на проверку. Обновите и повторите!',
  SubmittedSupervisorForApprovalSuccessfully: 'Успешно отправлено на проверку',
  ApprovedPass: 'Проверка утверждена!',
  ApprovalRejected: 'Проверка отклонена!',
  Problem: 'Проблема',
  Synchronized: 'Синхронизировано',
  NotSynchronized: 'Не синхронизировано',
  YouToEditTheAdministrator: 'Нет прав на редактирование. Обратитесь к администратору',
  SentOut: 'Отправлено!',
  DefaultPSettlementID: 'ID объекта расчетов по умолчанию',
  IsAREmpty: 'Пуст ли объект дебиторки по умолчанию?',
  IsAPEmpty: 'Пуст ли объект кредиторки по умолчанию?',
  TheFormCannotBeEmpty: 'Таможенная декларация обязательна!',
  ReminderOfTheCustomsData: 'Внимание: сохраните обязательные данные декларации перед загрузкой',
  ReminderOfTheCustomsPrint: 'Внимание: эти данные не передаются брокеру (только для печати)',
  ObtainActualBusinessData: 'Фактические бизнес-данные',
  TheToBeViewedAnyone: 'Файл недоступен для просмотра/скачивания',
  YouPermissionToViewDownload: 'Нет прав на просмотр/скачивание',
  File: 'Файл',
  PleaseInTheSubmissionNotes: 'Укажите комментарий при отправке',
  ContainsInvoicesThatCannotBeModified: 'Содержит неизменяемые счета',
  RemarksReviewedBy: 'Примечание проверяющего',
  numberingRuleCannotBeEmpty: 'Правила нумерации обязательны!',
  PortAreaDataComparison: 'Сверка портовых данных',
  ImportMode: 'Метод импорта',
  Keep: 'Сохранить',
  Explain: 'Пояснение:',
  BlackIsTheInputData: 'Черный - введенные данные,',
  BlueThePortAreaData: 'Синий - портовые данные,',
  GrayIsPreEnteredData: 'Серый - предварительные данные',
  UpdatedToPortAreaData: 'Обновить портовыми данными',
  lclCompareHarbourTips1: '1. По умолчанию полная замена (порт.данные заменят системные). Снятие отметки сохранит системные данные. Если снять все отметки - останутся исходные данные.',
  lclCompareHarbourTips2: '2. Красным выделены расхождения между системными и портовыми данными',
  lclCompareHarbourTips3: 'Срочно подтвердите корректные данные упаковки - это повлияет на SOP и уведомления',
  UpdatedData: 'Обновить данные',
  compareHarbourTips1: '1. По умолчанию полная замена (порт.данные заменят системные)',
  compareHarbourTips2: '2. Кликните номер контейнера для просмотра. Красное - расхождения данных',
  compareHarbourTips3: '3. Снятие отметки в [Другое] сохранит системные данные без добавления портовых. Снятие отметки у конкретного контейнера сохранит его системные данные. Если снять все - останутся исходные данные.',
  compareHarbourTips4: 'Срочно подтвердите корректные данные упаковки - это повлияет на SOP и уведомления',
  SystemEntry: 'Системный ввод',
  PortAreaData: 'Данные портовой зоны',
  ImportDescriptions: '导入类型为修改，为系统分别根据箱号、箱型、箱种帮您匹配到与港区一致的数据。\n导入类型为新增，为系统未找到与港区数据一致的数据。\n导入类型为保持，为您录入的数据未匹配到港区数据，即为您原始录入数据。',
  WhenTheBoxIsIdentifiedAsABox: 'Если груз обозначен как контейнер, номер таможенной декларации не отображается, а данные о количестве и весе показывают общий итог по грузу.',
  ClickEnteredDataPleaseOperation: 'Нажав "Обновить до данных портовой зоны", система обновит введенные данные в соответствии с выбранной информацией, а цвет шрифта изменится на черный. Пожалуйста, убедитесь в правильности данных перед выполнением.',
  Determine: 'Подтвердить',
  Cancel2: 'Отмена',
  PleaseAtLeastOneRecord: 'Пожалуйста, выберите хотя бы одну запись!',
  Hello: 'Здравствуйте',
  EnclosedPleaseFind: 'Пожалуйста, ознакомьтесь',
  PhotosOf: 'фотографии',
  ThankYou: 'Спасибо',
  TheAndFreightTermsBlank: 'Новые данные накладной (название судна/рейс, судоходная компания, основной номер накладной, агент по замене документов, дата отправления, предполагаемая/фактическая дата прибытия, склад, условия отпуска груза и фрахта) не соответствуют основной накладной, либо номер таможенной декларации накладной отсутствует.',
  TheModifyTheSmallContinue: 'Система изменит накладную. Продолжить?',
  SaveFailedSigh: 'Ошибка сохранения!',
  CellPhoneNumber2: 'Номер телефона',
  NoSopNodeMatched: 'Не найдено соответствие для текущей операции. Пожалуйста, выберите снова.',
  NameCannotBeEmpty: 'Имя не может быть пустым!',
  PleaseSelectARecord2: 'Пожалуйста, выберите запись.',
  ChangePassword: 'Изменить пароль',
  OriginalPassword: 'Старый пароль',
  NewPassword: 'Новый пароль',
  ConfirmPassword: 'Подтвердите пароль',
  ModificationPleaseLogInAgain: 'Пароль успешно изменен. Пожалуйста, войдите снова.',
  TheEnteredTwiceAreInconsistent: 'Введенные пароли не совпадают',
  DearUser: 'Уважаемый пользователь:',
  ItSystemInOrderMode: 'Обнаружен режим совместимости браузера, который может замедлить работу системы CargoWare. Для повышения производительности переключитесь в режим "Турбо".',
  TheShownInTheBelow: 'Инструкция показана ниже:',
  ToSwitchTutorialsSee: 'Инструкция по переключению:',
  GotIt: 'Понятно',
  FullScreen: 'Полный экран',
  EarlyWarningReminder: 'Оповещение',
  AnnouncementMessage: 'Объявления',
  Cancellation: 'Выйти',
  FlagshipEdition: 'Флагманская версия',
  BasicEdition: 'Базовая версия',
  TrialCustomers: 'Пробный клиент',
  FormalCustomer: 'Официальный клиент',
  SystemAdministrator: 'Системный администратор',
  RefreshCacheMethod: 'Как обновить кэш',
  AfterTheCorrespondingCacheData: 'После изменения базовых данных обновите соответствующий кэш для получения актуальной информации.',
  ViewCacheRefreshMethod: 'Инструкция по обновлению кэша',
  PleaseExitTheEditingModule: 'Пожалуйста, сначала сохраните изменения или выйдите из режима редактирования перед закрытием модуля.',
  SessionPleaseLogInAgain: 'Время сеанса истекло. Пожалуйста, войдите снова.',
  EDITemplateExceptionDownloadFailed: 'Ошибка шаблона EDI, загрузка не удалась...',
  One: 'Один',
  Two: 'Два',
  Three: 'Три',
  Four: 'Четыре',
  Five: 'Пять',
  Six: 'Шесть',
  Just: 'Только что',
  MinutesAgo: 'Минут назад',
  HoursAgo: 'Часов назад',
  OneDayAgo: '1 день назад',
  LastWeek: 'За последнюю неделю',
  LastMonth: 'За последний месяц',
  LastThreeMonths: 'За последние три месяца',
  PleaseSelectDataFirst: 'Пожалуйста, сначала выберите данные',
  SelfBooking: 'Самостоятельное бронирование',
  CommissionedBooking: 'Бронирование по доверенности',
  CustomerSelfBooking: 'Бронирование клиентом',
  OwnContractPrice: 'Собственная договорная цена',
  CustomerOffer: 'Договорная цена клиента',
  OverseasAgentContractPrice: 'Договорная цена зарубежного агента',
  UncommittedPrice: 'Без договорной цены',
  PeerAgreementPrice: 'Договорная цена коллег',
  BuyerLCL: 'Консолидация BUYER',
  InnerPacking: 'Внутренняя упаковка,',
  DoorPointPacking: 'Упаковка на месте,',
  SelfPullingAndSelfSending: 'Самовывоз и самодоставка,',
  DeclareAtCustoms: 'Таможенное оформление,',
  Fumigation: 'Фумигация,',
  CommodityInspection: 'Товарная экспертиза,',
  BookingSpace: 'Бронирование,',
  SetSpell: 'Консолидация',
  PersonalBelongings: 'Личные вещи',
  OneMasterAndManyPoints: 'Один главный, несколько подчиненных',
  OneMasterAndOneMinute: 'Один главный, один подчиненный',
  UnknownType: 'Тип неизвестен',
  Marked: 'Отмечено',
  Unmark: 'Не отмечено',
  PendingOrder: 'Ожидание заказа',
  OrderPlaced: 'Заказ оформлен',
  ReceivedOrder: 'Заказ принят',
  NotIssued: 'Не выдано',
  Issued: 'Выдано',
  Retrieved: 'Получено',
  Accepted: 'Принято',
  Claimed: 'Заявлено',
  ChangeOrder: 'В процессе изменения',
  ApprovedBusinessCannotBeEdited: 'Проверенные операции нельзя редактировать.',
  OrderAlreadyApproved: 'Заказ {0} уже утвержден.',
  YouPermissionToEditNotes: 'У вас нет прав на редактирование этого документа.',
  EnglishNameOfHBLConsignee: 'Английское название получателя HBL',
  EnglishNameOfHBLShipper: 'Английское название отправителя HBL',
  AgentNetworkCustomerService: 'Служба поддержки агентской сети',
  ReImportAfterModification: 'Можно изменить и повторно импортировать',
  DownloadFailedData: 'Данные о неудачной загрузке',
  TheCaseOfMultipleFirst: 'Продление срока не рекомендуется при множественном выборе, сначала проверьте, нет ли лишних отметок!',
  InvalidNumberEntered: 'Введено недопустимое число!',
  TheOrThePartnerSigned: 'Этот клиент уже подписал договор или этот партнер уже подписал договор!',
  FirstDateCannotBeBlank: 'Дата первого контакта не может быть пустой!',
  PleaseInTheTelephoneNumber: 'Пожалуйста, укажите номер телефона!',
  PleaseRemoveTheTicketFirst: 'Сначала удалите чек',
  ExpenseHasBeenEntered: 'Расходы уже внесены',
  ConsolidationHasBeenDone: 'Объединение уже выполнено',
  Save: 'Сохранить?',
  PleaseEnterCurrencyExchangeRate: 'Введите курс валюты',
  FailedOpenSalesQueryDetails: 'Не удалось открыть детали запроса продаж!',
  pleaseEnterTemplateName: 'Введите название шаблона',
  blank: 'Пусто',
  PartnersBeenAddedToBlacklist: 'Партнер добавлен в черный список!',
  ThisCustomerRiskyCustomerOperateOrdersWithCaution: 'Это клиент, который осторожно {0} заказы для рискованных клиентов',
  AlreadyExistsOverwriteOriginalScheme: 'Название схемы уже существует, перезаписать существующую схему?',
  NoDataToSave: 'Нет данных для сохранения',
  ColumnSettings: 'Настройка столбцов',
  CurrentPage: 'Текущая страница',
  CurrentSelection: 'Текущий выбор',
  NoModificationAllowedAfterBusinessSubmission: 'После отправки заявки изменения будут запрещены, перед отправкой убедитесь, что все необходимые файлы загружены',
  AboutToUploadFiles: 'Скоро будет загружен файл',
  SuccessfullyUploaded: 'Файл успешно загружен',
  RetrievalOfAssignedPermissions: 'Поиск назначенных прав',
  UploadResults: 'Результат загрузки',
  OnlyFilesFormatCanUploaded: 'Можно загружать только файлы формата {0}',
  VolumeAbnormalAndCannotUploaded: 'Некорректный размер файла, загрузка невозможна.',
  VolumeExceeds5mAndCannotUploaded: 'Размер файла превышает 5 МБ, загрузка невозможна.',
  VolumeExceeds20mAndCannotUploaded: 'Размер файла превышает 20 МБ, загрузка невозможна.',
  PlaceOfDeliverySeaport: 'Место доставки (морской порт)',
  PlaceOfDeliveryAirport: 'Место доставки (аэропорт)',
  SailingDay: 'Дата отправления',
  BusinessCreationDate: 'Дата создания заявки',
  DeliveryStation: 'Станция доставки',
  NoDocumentsDeclaringOrNonSpermWhaleUsers: 'Документы не найдены, возможно, они находятся на оформлении или пользователь не является клиентом "Кашалот".',
  HasContainerNoOrSealNoForSameEqTypeAndEqSize: 'Этот тип контейнера уже связан с информацией о пломбах, синхронизировать изменение типа контейнера на вкладке информации о загрузке?',
  SeaEqAsyncToContainerTip: 'Информация о пломбах уже введена, сначала удалите её на вкладке информации о загрузке!',
  TheSynchronizedFileCannotBeEdited: 'Синхронизированные файлы нельзя редактировать',
  TheSynchronizedFileIsNotDeleted: 'Синхронизированные файлы нельзя удалять',
  CurrentBusinessStatusCannotBeSynchronized: 'Текущий статус заявки не позволяет синхронизацию',
  TheSynchronizedExpensesCannotBeDeleted: 'Синхронизированные расходы нельзя удалить, сначала отмените синхронизацию расходов.',
  CurrentlyThereIsNoSynchronizationCosts: 'Нет расходов для синхронизации',
  ThereAreCurrentlyNoCancellableCharges: 'Нет расходов для отмены',
  NoCurrentChargesCanBeCancelled: 'Нет синхронизированных расходов для отмены',
  ChargeItemChangeTip: 'Информация о расчетах по умолчанию для этого расхода не соответствует текущему расходу, обновить?',
  SubscriptionInformation: 'Настройте (дочерние) компании, которые будут получать подписки',
  SetUpThePartners: 'Настройте партнеров, на которых нужно подписаться',
  PleaseSelectAInformation: 'Выберите тариф.',
  ThisRateHasExpired: 'Этот тариф устарел!',
  ExternalUsersCannotEdit: 'Внешние пользователи не могут редактировать, перейдите на вкладку электронной коммерции партнеров.',
  CommunicationConfirmation: 'В период действия тарифа не найдена дата отправления, соответствующая расписанию, согласуйте с заказчиком бронирования!',
  CombineTips: 'Нельзя выбрать основной документ для объединения!',
  RepeatMblForSave: 'Основной номер накладной повторяется, подтвердить сохранение?',
  SystemAlert: 'Системное уведомление',
  NotRepeatOperation: 'Статус изменён, пожалуйста, не повторяйте действие.',
  FeesHaveBeenUsedForEditUnit: 'Данный код единицы уже используется в расходах, изменение невозможно!',
  TheChargingUnitIsUsedByAnExistingChargePlanForEditUnit: 'Данный код единицы тарификации уже используется в схеме расходов, изменение невозможно!',
  ApplyChangeChargeNotThrough: 'Уже {0}, невозможно {1}, пожалуйста, выберите заново.',
  KingdeeNotExist: 'Данные не требуют синхронизации или отсутствуют в системе Kingdee',
  ByAdjustmentDate: 'По дате корректировки',
  ByBusinessDate: 'По дате операции',
  PleaseEnterTheFileType: 'Введите тип файла',
  NotExportToImportBusiness: 'Этот документ не является операцией экспорта в импорт, синхронизация невозможна!',
  JobNotOperateStatus: 'Этот документ не в статусе активной операции, синхронизация невозможна!',
  JobShutOut: 'По этому документу оформлен отказ от таможенного оформления, синхронизация невозможна!',
  ChargeSyncSuccess: 'Синхронизация расходов успешно завершена!',
  NoSynchronizedFees: 'Нет расходов для синхронизации!',
  SaveColumnSettingsSameTime: 'Сохранить текущие настройки отображаемых столбцов',
  SaveScheme: 'Сохранить схему',
  ReceivableCharge: 'Дебиторская задолженность (расходы)',
  PayableCharge: 'Кредиторская задолженность (расходы)',
  TruckingNotExist: 'Информация о контейнере отсутствует!',
  SaveDisplayColumns: 'Сохранить отображаемые столбцы',
  NoPermissionToAddExpense: 'Нет прав на добавление расходов',
  NoPayableAddPermissionCannotImported: 'У вас нет прав на добавление кредиторских расходов, нет расходов для импорта',
  NoPayableAddPermissionOnlyImportReceivable: 'У вас нет прав на добавление кредиторских расходов, импортируются только дебиторские расходы',
  NoReceivableAddPermissionCannotImported: 'У вас нет прав на добавление дебиторских расходов, нет расходов для импорта',
  NoReceivableAddPermissionOnlyImportPayable: 'У вас нет прав на добавление дебиторских расходов, импортируются только кредиторские расходы',
  OnlyRejectedBusinessesCanDelete: 'Можно удалять только отклонённые операции',
  OnlyRejectedBusinessesCanDeleteIgnoreOther: 'Можно удалять только отклонённые операции, остальные операции проигнорированы',
  SuccessfullySubmittedXBusiness: 'Успешно отправлено {num} операций',
  SuccessfullySubmittedXBusinessOtherIgnore: 'Успешно отправлено {num} операций, остальные операции не соответствуют условиям отправки из-за статуса предварительной проверки',
  SuccessfullyRevokedXBusiness: 'Успешно отозвано {num} операций',
  SuccessfullyRevokedXBusinessOtherIgnore: 'Успешно отозвано {num} операций, остальные операции не соответствуют условиям отзыва из-за статуса предварительной проверки',
  SuccessfullyConvertRealXBusiness: 'Успешно преобразовано в официальные операции: {num}',
  SuccessfullyConvertRealXBusinessOtherIgnore: 'Успешно преобразовано в официальные операции: {num}, остальные операции не соответствуют условиям преобразования из-за статуса предварительной проверки',
  ChargeSyncJobStateCheckFail: 'Проверка статуса операции синхронизации расходов не пройдена',
  HaveChargeNotAllocatedAndtoContinue: 'Имеются нераспределённые расходы, подтвердите продолжение синхронизации расходов?',
  PartnerAlreadyExistPleaseSelectOfficialCustomer: 'Партнёр уже существует, выберите среди официальных клиентов',
  PartnerHasMaintainedUndeToContinue: 'Данный партнёр уже зарегистрирован в подразделении 【{officeCode}】, продолжить создание?',
  fileManagement: 'Управление файлами',
  FilterValue: 'Значение фильтра',
  PriceAndNumIsNull: 'Цена за единицу и количество пусты, продолжить?',
  SyncContainerSealNoToBillOfLading: 'Синхронное обновление номеров контейнеров/пломб в информации о коносаменте',
  AssociatedBillOfLadingCannotDelete: 'Связано с коносаментом, удаление невозможно',
  AssociatedBillOfLadingCannotRemove: 'Связано с коносаментом, удаление невозможно',
  SettlementObjectAccountPeriod: 'Расчётный период контрагента',
  InvoiceHeaderDifferent: 'Реквизиты в счетах не совпадают, продолжить?',
  Agreement: 'Совпадает',
  NotAgreement: 'Не совпадает',
  AllocationNature: 'Тип распределения',
  VirtualAllocation: 'Виртуальное распределение',
  ActualSplit: 'Фактическое разделение',
  ShareTypeTip: 'Совпадает: все расходы имеют одинаковый тип распределения, изменение типа одного расхода приводит к аналогичному изменению всех остальных\nНе совпадает: расходы могут иметь разные типы распределения, изменение типа затрагивает только текущий расход',
  VirtualAllocationAndActualSplitTip: '虚拟分摊：在主单进行做账单、开票、付款申请、销账等结算\n分摊到小票的费用是虚拟的，仅能查看，不进行实质性的结算。\n\n真实拆分：分摊后的费用在分单进行做账单、开票、付款申请、销账等结算\n如主单的费用已经结算则不能拆分费用到小票',
  ActualSplitWarn: 'Внимание: После фактического разделения исходные расходы основного счета не сохраняются и не могут быть восстановлены. Пожалуйста, действуйте осторожно!',
  CannotActualSplitTip: 'После выставления счета, выписки счета-фактуры, подачи заявки на оплату, списания и других расчетных действий по основному счету нельзя разделить расходы на субсчета!',
  SharedChargeTotal: 'Общая сумма распределенных расходов',
  DataHadUpdated: 'Данные были изменены, пожалуйста, выполните повторный запрос',
  OpenSOPPanelNeedDoubleClick: 'Чтобы открыть панель SOP, дважды щелкните статус операции.',
  Operator: 'Оператор',
  HaveInHand: 'В процессе',
  Exception: 'Ошибка',
  TerminalCompany: 'Портовая компания',
  TerminalLocation: 'Портовая компания',
  DeliveryAddress: 'Адрес получения груза',
  TerminalAddress: 'Адрес получения груза',
  TcDeliveryAddress: 'Информация об адресе получения груза портовой компании',
  ResultLogUploadFaild: 'Не удалось загрузить журнал результатов в облачное хранилище, повторите попытку!',
  ConfigureDisplayColumns: 'Настройка отображаемых столбцов',
  AllNames: 'Все названия',
  SelectedColumns: 'Выбранные столбцы',
  NoPermissionViewSecondaryTable: 'У вас нет прав на просмотр информации вторичной таблицы!',
  NoPermissionSetSecondaryTableColumns: 'У вас нет прав на настройку отображаемых столбцов вторичной таблицы!',
  UpdateNoticeDetails: 'Уведомление об обновлении [подробности]',
  DontRemindMeAgain: 'Больше не напоминать',
  NewInnerContractNo: 'Создать внутренний номер договора',
  EditInnerContractNo: 'Изменение внутреннего номера договора',
  AreYouSureToCancelThisData: 'Подтвердить отмену этих данных?',
  HasBeenUsedAndCannotEditContractNo: 'Уже используется, нельзя редактировать номер договора',
  HasBeenUsedAndCannotBeDeleted: 'Уже используется, нельзя удалить',
  ApplicableRoute: 'Применимые маршруты',
  IsEnable: 'Активировано',
  ContractNoUseState: 'Статус использования номера договора',
  NotUse: 'Не используется',
  Occupies: 'Занято',
  DataLoadingFailed: 'Не удалось загрузить данные...',
  ExportExcel: 'Экспорт в Excel',
  ExportExcel2: 'Экспорт в EXCEL',
  ExportPDF: 'Экспорт в PDF',
  ExportWord: 'Экспорт в WORD',
  ExportPPT: 'Экспорт в PPT',
  NoDataIsCurrentlySelected: 'Данные не выбраны',
  SelectAll: 'Выбрать все',
  CustomerSelfIssue: 'Клиентский самовывоз',
  Clear: 'Очистить',
  QuickOfLadingNumberCustomsNumber: 'Быстрый поиск: номер операции/номер коносамента/номер таможенной декларации',
  QuickMnemonicabbreviationChineseAndEnglishNames: 'Быстрый поиск: мнемонический код/сокращенное название/название на китайском и английском',
  InvoiceNumber: '/Номер счета-фактуры',
  BusinessNumber: '/Номер операции',
  BillingNumber: '/Номер счета',
  PaymentApplicationNumber: '/Номер заявки на оплату',
  VerificationNumber: '/Номер списания',
  ReconciliationNumber: '/Номер сверки',
  ActualPaymentAndReceiptNumber: '/Номер фактического платежа',
  DeliveryOrderNumber: '/Номер выпуска документов',
  ProgramNumber: '/Номер схемы',
  QuickSearch: 'Быстрый поиск',
  SearchBeRemovedNotFound: 'Не найдено searchItem для исключения',
  Error3: 'Ошибка',
  AdvancedSchemeLoadingFailed01: 'Ошибка загрузки конфигурации расширенного запроса 01=:',
  TheFoundPleaseSelectScheme: 'Схема не найдена, выберите другую',
  AreYouWantToDelete: 'Вы уверены, что хотите удалить?',
  Tip: 'Подсказка',
  DeleteSchemeFailed: 'Ошибка удаления схемы:',
  N1Exceeds4MBCannotUploaded: 'Размер файла превышает 4 МБ, загрузка невозможна.',
  N1Exceeds20MBCannotUploaded: 'Размер файла превышает 20 МБ, загрузка невозможна.',
  DeleteFileFailed: 'Ошибка удаления файла!',
  Edit: 'Редактировать',
  SelectFile: 'Выбрать файл',
  DeleteFile: 'Удалить файл',
  Upload: 'Загрузить',
  UploadFile: 'Загрузить файл',
  FileName: 'Имя файла',
  FileType: 'Тип файла',
  FileSize: 'Размер файла',
  Uploader: 'Загрузивший',
  UploadTime: 'Время загрузки',
  UploadProgress: 'Прогресс загрузки',
  Uploading2: 'Загрузка...',
  WaitingForUpload: 'Ожидание загрузки',
  DocumentCategory: 'Категория документа',
  PlatformCustomerService: 'Служба поддержки платформы',
  Yes: 'Да',
  No: 'Нет',
  Confirm: 'Подтвердить',
  SaveColumnStatus: 'Сохранить состояние столбцов',
  ResetColumnStatus: 'Сбросить состояние столбцов',
  SaveColumnStatusSuccess: 'Состояние столбцов успешно сохранено',
  SaveColumnStatusFailed: 'Ошибка сохранения состояния столбцов',
  ResetColumnStatusSuccess: 'Состояние столбцов успешно сброшено',
  ChatWindow: 'Окно чата',
  Internal: 'Внутренний',
  Communication: 'Общение',
  InternalCommunication: 'Внутреннее общение',
  ExternalCommunication: 'Внешнее общение',
  Customer: 'Клиент',
  Reset: 'Сбросить',
  Search: 'Поиск',
  CurrentlySelectedItem: 'Текущий выбранный элемент:',
  Port: 'Порт',
  State: 'Штат',
  FileAbnormalCannotBeUploaded: 'Некорректный размер файла, загрузка невозможна.',
  File20MCannotBeUploaded: 'Размер файла превышает 20 МБ, загрузка невозможна.',
  UploadSuccessful: 'Загрузка успешна',
  ImportFile: 'Импорт файла',
  PrintTemplate: 'Шаблон печати:',
  Code: 'Код',
  ChineseName: 'Имя на китайском',
  EnglishName: 'Имя на английском',
  Country: 'Страна',
  Region: 'Регион',
  Name2: 'ФИО',
  StartDate: 'Дата начала',
  To: 'до',
  EndDate: 'Дата окончания',
  CurrentAuthorizations: 'Текущие разрешения',
  Refresh: 'Обновить',
  User: 'Пользователь:',
  Authorization: 'Авторизация',
  Time: 'Время:',
  AuthorizationUseHistory: 'История авторизаций:',
  AuthorizationFailed: 'Ошибка авторизации',
  SendTest: 'Тестовая отправка',
  CurrentPersonalAuthorizationList: 'Текущий список личных разрешений',
  SendTo: 'Отправить:',
  Confirm2: 'Подтвердить',
  Cancel: 'Отмена',
  Close: 'Закрыть',
  Open: 'Открыть',
  AuthorizationItemDescription: 'Описание разрешения',
  AuthorizationItem: 'Разрешение',
  AuthorizationStatus: 'Статус авторизации',
  NotSet: 'Не установлено',
  StatusChangeTime: 'Время изменения статуса',
  Operation: 'Действие',
  PleaseAddProductDescriptionHere: 'Добавьте описание продукта здесь',
  WeChatMessagePush: 'Push-уведомления WeChat',
  MarqueeSwitch: 'Бегущая строка',
  PleaseInEmailPasswordauthorizationCode: 'Введите пароль/код авторизации почты!',
  PleaseFillInRecipientEmail: 'Введите email получателя!',
  EmailSettingsTestEmail: 'Настройки почты - тестовое письмо',
  SendSuccessfully: 'Отправка успешна',
  PaymentUponReceipt: 'Отгрузка после оплаты',
  All: 'Все',
  Unread: 'Непрочитанные',
  Read: 'Прочитанные',
  MMDDDayHHMm: 'MM.DD HH:mm',
  AssignSales: 'Назначить продавца',
  ReleaseSales: 'Освободить продавца',
  ReviewSales: 'Проверка продаж',
  SuccessfullyGrabCustomer: 'Клиент успешно перехвачен',
  GrabCustomerFailed: 'Ошибка перехвата клиента',
  ScheduleReminder: 'Напоминание',
  CustomerExpirationReminder: 'Напоминание о сроке клиента',
  BusinessReviewReminder: 'Напоминание о проверке операций',
  CustomsDeclarationReminder: 'Напоминание о таможенном оформлении',
  AbnormalHandlingOfBox: 'Обработка аномалий контейнера',
  DeparturePickUpContainerWarning: 'Предупреждение о заборе контейнера',
  BoxArrivingAtFactoryWarning: 'Предупреждение о прибытии контейнера на завод',
  BoxLeavingFactoryWarning: 'Предупреждение об отправке контейнера с завода',
  CustomsReleaseWarning: 'Предупреждение о таможенном выпуске',
  TerminalReleaseWarning: 'Предупреждение о выпуске в порту',
  BoardingWarning: 'Предупреждение о погрузке на судно',
  DepartureWarning: 'Предупреждение об отходе из порта',
  ArrivalWarning: 'Предупреждение о прибытии в порт',
  ReturningBoxWarning: 'Предупреждение о возврате контейнера',
  SystemArrearsReminder: 'Напоминание о задолженности в системе',
  ChangeReviewAndApprovalReminder: 'Напоминание о согласовании изменения расходов',
  DefaultMessage: 'Сообщение по умолчанию',
  Message: 'Системное сообщение',
  SelectTemplate: 'Выбор шаблона',
  PleaseSelectTheExportTemplate: 'Пожалуйста, выберите шаблон экспорта',
  Upload0UploadFailure0: 'Успешно загружено: {0}, не удалось загрузить: {1}.',
  SuccessfulFailure0ConfirmSave: 'Успешно загружено: {0}, ошибок: {1}. Подтвердить сохранение?',
  Only0FormatCanUploaded: 'Можно загружать только файлы формата {0}',
  YouToOpenTheModule: 'У вас нет прав на доступ к модулю "{0}"',
  Upload0UploadFailed0: 'Успешно загружено: {0}, не удалось загрузить: {1}.',
  All2: '(Все)',
  NumberOfPiecescommissionactual: 'Количество мест (заказ/факт)',
  LetterOfCreditTerms: 'Условия аккредитива',
  N4InsuranceCompletion: '4. Страхование завершено',
  N2Inquiry: '2. Запрос цены',
  SensitiveWords: 'Чувствительные слова',
  FreightRateDetails: 'Детали тарифа',
  Manufacturer: 'Производитель',
  ShipName: 'Название судна:',
  IsItCorrect: 'Правильно ли это.',
  BoxReturnedFromTheArea: 'Информация о грузе контейнера от порта:',
  CurrentlyStatusAndCannotDeleted: 'В настоящее время редактируется, удаление невозможно',
  ChineseAbbreviationOfTheCompany: 'Краткое название компании на китайском:',
  TheTheCompanyCannotEmpty: 'Краткое название компании на английском не может быть пустым',
  Voyage: 'Рейс:',
  ShippingSchedule: 'Расписание судна: ',
  PortOfDepartureUpdate: 'Обновление порта отправления',
  DestinationPortUpdate: 'Обновление порта назначения',
  ChatInside: 'Внутренняя коммуникация',
  ChatByClient: 'Внешняя коммуникация',
  DoubleClickToSelectState: 'Двойной щелчок для выбора статуса запроса',
  StateQuery: 'Запрос статуса',
  EdiStateQuery: 'Запрос статуса EDI',
  BookingEdiSendType: 'Канал EDI для бронирования',
  BookingEdiSendTime: 'Время EDI бронирования',
  imConnecting: 'Пытаемся подключиться.....',
  imConnectFailed: 'Не удалось установить соединение. Закройте и снова откройте.',
  SwitchBranchAndOpenModuleTipAllEdit: 'Перед переключением филиала сохраните данные и закройте открытые модули. В настоящее время открыто {0} модулей. Закрыть все модули?',
  SwitchBranchAndOpenModuleTipNotEdit: 'Перед переключением филиала закройте открытые модули. В настоящее время открыто {0} модулей. Закрыть все?',
  SwitchBranchAndOpenModuleTipPartEdit: 'Перед переключением филиала сохраните данные и закройте модули. В настоящее время {0} модулей не сохранены и не закрыты. Закрыть все?',
  PrintRecordsOverLimitTip: 'Количество записей для печати превышает системный лимит. Экспортировать напрямую?',
  PrintRecordsOver100Tip: 'Количество записей для печати превышает 100. Загрузка может занять больше времени. Экспортировать напрямую?',
  ContinuePreview: 'Продолжить предпросмотр',
  NotSupported: 'Отображение сцепленных данных для {0} рейсов пока не поддерживается',
  PleaseFillInCorrectly: 'Пожалуйста, правильно заполните информацию о нескольких рейсах, пустые поля не допускаются',
  DoNotEmpty: 'Данные первого рейса нельзя очищать',
  AirlineReplacement: 'Авиакомпания первого рейса изменилась. Информация об аэропорте отправления (аэропорт, фактическое время прибытия, фактическое время погрузки, расчетное время вылета, фактическое время вылета) будет очищена, и данные будут получены заново',
  AirlineReplacement1: '1. Измененная авиакомпания отсутствует в списке поддерживаемых подписок, данные не будут получены',
  AirlineReplacement2: '2. Авиакомпания первого рейса изменилась. Информация об аэропорте отправления (аэропорт, фактическое время прибытия, фактическое время погрузки, расчетное время вылета, фактическое время вылета) будет очищена',
  AirlineReplacementLast: 'Авиакомпания последнего рейса изменилась. Информация об аэропорте назначения (расчетное время прибытия, фактическое время прибытия, фактическое время получения документов, фактическое время разгрузки, фактическое время уведомления о прибытии, фактическое время получения груза) будет очищена, и данные будут получены заново',
  AirlineReplacementLast2: '2. Авиакомпания последнего рейса изменилась. Информация об аэропорте назначения (расчетное время прибытия, фактическое время прибытия, фактическое время получения документов, фактическое время разгрузки, фактическое время уведомления о прибытии, фактическое время получения груза) будет очищена',
  ViewShippingTracking: 'Если есть несколько рейсов с разными авиакомпаниями, данные см. на вкладке [Отслеживание перевозок]',
  IntermediateAirline: 'Измененная авиакомпания отсутствует в списке поддерживаемых подписок, данные второго рейса не будут получены',
  ExportingPleaseWait: 'Идет экспорт файла, пожалуйста, подождите',
  ExportTakePlaceInBackground: 'Вы можете покинуть страницу, экспорт будет продолжен в фоновом режиме',
  CompletionDownloadMessageReminderInRightCorner: 'После завершения загрузите файл в разделе "Уведомления" {0} в правом верхнем углу.',
  FileExportCompletionReminder: 'Уведомление о завершении экспорта файла',
  SyncPartnerToFinanceCodeReminder: 'Уведомление о завершении импорта кодов контрагентов',
  NoNewPermissionsForFees: 'Нет прав на добавление расходов',
  NoPayChargesImport: 'У вас нет прав на добавление дебиторской задолженности, нет расходов для импорта',
  NoCostChargesImport: 'У вас нет прав на добавление кредиторской задолженности, нет расходов для импорта',
  OnlyCostChargesImport: 'У вас нет прав на добавление дебиторской задолженности, импортируются только кредиторские расходы',
  OnlyPayChargesImport: 'У вас нет прав на добавление кредиторской задолженности, импортируются только дебиторские расходы',
  ConfirmDeleteN: 'Подтвердите удаление {0} записей?',
  AffiliatedBranchStyle: 'Стиль принадлежности к филиалу',
  DisplayByOrganizationalStructure: 'Отображать по организационной структуре',
  AllDisplay: 'Показать все',
  FileView: 'Просмотр файла',
  NotPermissionToEditFilesByOtherUsers: 'Недостаточно прав: нет доступа для редактирования файлов, загруженных другими пользователями',
  NotMatchingTheCostOfTheProjectCanBeDelete: 'Нет соответствующих статей расходов для удаления.',
  ThisPartnerDoesNotSupportEnterReceivableFees: 'Этот партнер не поддерживает ввод дебиторской задолженности',
  ThisPartnerDoesNotSupportEnterPayableFees: 'Этот партнер не поддерживает ввод кредиторской задолженности',
  Can_Changed: 'Можно изменить накладную',
  Customer_Service: 'Отдел обслуживания клиентов',
  Documentation_Department: 'Отдел документации',
  Countries_Regions_Destination: 'Страна/регион порта назначения',
  CargoDocAndContainerQWTNotSame: 'Информация о погрузке в коносаменте не соответствует информации о погрузке в бизнес-данных!',
  Some_Items_Have_Expired: 'Некоторые статьи расходов устарели, копирование не удалось',
  SentDestinationPortAgentTip: 'Письмо в порт назначения уже было отправлено с помощью функции "Отправить одним кликом"',
  SendFileVerification: 'Проверка отправляемых файлов',
  SendFileVerificationSuccessTip: 'Проверка файла успешно завершена. Нажмите [Далее] для продолжения отправки письма или [Отмена]',
  SendFileVerificationExceptionTip: 'Обнаружена ошибка при проверке файла. Нажмите [Далее] для продолжения отправки письма или [Отмена]',
  Validating: 'Статус проверки',
  MasterCheckExist: 'Проверка главной накладной: существует ли {0}',
  SmallCheckExist: 'Проверка дополнительной накладной: существует ли {0}',
  EmailAttachments: 'Вложение письма',
  DeleteAttachTip: 'Вы уверены, что хотите удалить это вложение?',
  LocalEmailSentSuccess: 'Локальная почта успешно отправлена?',
  LocalEmailTooLarge: 'Содержимое письма слишком большое, невозможно перейти в локальный почтовый ящик!',
  Lack: 'Отсутствует',
  FileDragArea: 'Перетащите файлы в эту область для загрузки',
  EnterKeyword: 'Введите ключевое слово',
  ClearSelectedItems: 'Очистить выбранное',
  ManifestFileNumBox: 'Количество файлов MANIFEST равно количеству контейнеров',
  ManifestFileNumNotEqualBox: '【Количество контейнеров】: {0} /【MAINFIEST】 количество файлов: {1}, несоответствие между файлами MANIFEST и количеством контейнеров',
  TheSelectedDataIsIgnoredSuccessfully: 'Выбранные данные успешно проигнорированы',
  SelectedDataHasBeenBatchProcessedSuccessfully: 'Отмена игнорирования выбранных данных прошла успешно',
  ThereAreNoNegligibleCosts: 'Нет расходов для игнорирования',
  ThereAreNoFeesThatCanBeEliminated: 'Нет расходов для отмены игнорирования',
  OnlyUnRead: 'Только непрочитанные',
  AllMarksRead: 'Отметить все как прочитанные',
  MessageConfig: 'Настройки сообщений',
  SaleProductCodeCannotBeNull: 'Продукт для продажи не может быть пустым',
  FullOrInsideCannotBeNull: 'Поле "Международный/Внутренний" не может быть пустым',
  NotNullForMapping: 'На основной вкладке поля "【Продукт для продажи】" и "【Международный/Внутренний】" не могут быть пустыми. Введите данные перед выбором расходов',
  DifferentJobOrBusinessFieldValues: 'Выбранные операции содержат несколько разных должностей или значений полей. Если не задано, будут сохранены исходные должности и значения полей',
  PreserveOriginalValue: 'Оставить исходное',
  SelectSynchronizedFields: 'Выберите поля для синхронизации',
  SynchronizedFields: 'Синхронизировать поля',
  RunSuccess: 'Успешно выполнено',
  RunFail: 'Ошибка выполнения',
  PleaseUpload: 'Исходное значение пусто, загрузите файл',
  CodeTip: '1. Язык кода здесь: javascript\n2. Имя объекта по умолчанию для обработки: result. (Все содержимое result - это JSON-объект исходных значений)\n3. Чтобы получить первый элемент, используйте: result[0]. (Элементы нумеруются с 0)\n4. Чтобы получить значение определенного поля, используйте: result[0].text.data[\'упаковка\']\n5. Чтобы изменить значение упаковки, используйте: result[0].text.data[\'упаковка\'] = \'PPK\'\n6. Чтобы заменить все значения "P" в упаковке, используйте: result[0].text.data[\'упаковка\'] = result[0].text.data[\'упаковка\'].replaceAll(\'P\',\'B\');',
  BlIsIssued: 'Коносамент уже выдан',
  NoVirtualHBLTip: 'В этой операции нет разделения по формам. Сначала отметьте разделение по формам, затем выполняйте действия',
  NoVirtualHBLAuthTip: 'Нет прав на эту вкладку. Обратитесь к администратору для настройки прав на разделение по формам!',
  FieldValueCannotBeNull: '{0} не может быть пустым',
  ImportFailedFileNameNotMatch: 'Ошибка импорта: имя файла не начинается с ISF5 или ISF10',
  ISF5File: 'Шаблон ISF5',
  ISF10File: 'Шаблон ISF10',
  BookingLabel: 'Вкладка бронирования',
  BatchPurchasePriceLock: 'Выберите операции с незаблокированной покупной ценой для выполнения действий.',
  BatchPurchasePriceUnLock: 'Выберите операции с заблокированной покупной ценой для выполнения действий.',
  BatchSellingPriceUnLock: 'Выберите операции с заблокированной продажной ценой для выполнения действий.',
  BatchSellingPriceLock: 'Выберите операции с незаблокированной продажной ценой для выполнения действий.',
  NotPermissionToViewFiles: 'Есть файлы {0}, на которые нет прав просмотра. Нельзя отправить письмо с ними',
  ContainerTotalNeedEqual: 'Суммарные значения контейнера 【количество внешней упаковки】【количество внутренней упаковки】【брутто】【нетто】 должны соответствовать общему количеству в номере специального груза',
  PackingAddNotRepeat: 'Выбранная информация о загрузке уже добавлена, не добавляйте повторно',
  selectRequirement: 'Двойной щелчок для выбора требований к операции',
  DataGroup: 'Группировка данных',
  CloseRefreshNeedMannulUpdate: 'При отключении автоматического обновления необходимо вручную нажимать 【Обновить】 для обновления данных!',
  RefreshRule: 'Правила обновления:',
  NodeRecord: 'Запись узлов:',
  HomePageNotRefreshData: 'Не обновлять данные автоматически при входе на главную страницу',
  DisplayLastClickNode: 'Показывать последний нажатый узел',
  RetainQueryCondition: 'И сохранять условия запроса для этого узла',
  N0VerificationPassed: '【{0}】 проверка пройдена',
  ConsigneeCompanyName: 'Название компании получателя',
  TaskBoard: 'Доска задач:',
  AlertNode: 'Узел предупреждения:',
  DoOfQueryResultsTemplates: 'Не отображать в зависимости от количества результатов запроса, сбросить условия запроса при переключении шаблона',
  SendPortAgentByNumber: 'Отправить агента порта назначения по номеру контейнера',
  SendAgentByCaseNumber: 'Отправить агента комплекта по номеру контейнера',
  SetOrderAgency: 'Агент комплекта',
  LastSentTime: 'Время последней отправки',
  ShippingCompanyCannotBeModifiedBylclMasterUuid: 'Изменение судоходной компании запрещено, если Master LCL не пуст',
  ShippingCompanyCannotBeModifiedByCharge: 'Изменение судоходной компании запрещено из-за существующих расходов',
  ShippingCompanyNotExist: 'Судоходная компания не существует',
  AirCompanyCannotBeModifiedBylclMasterUuid: 'Изменение авиакомпании запрещено, если Master LCL не пуст',
  AirCompanyCannotBeModifiedByCharge: 'Изменение авиакомпании запрещено из-за существующих расходов',
  AirCompanyNotExist: 'Авиакомпания не существует',
  SeToSiCannotBeUpdatedToShippingCompany: 'Изменение судоходной компании запрещено для междутенантных операций Export-to-Import',
  BusinessOperationsCannotBeModified: 'Есть связанные грузовые места с бизнес-статусами "Проверено", "Отправлено", "Предварительная отправка" или "В процессе отправки". Невозможно изменить через массовый перевод судна. Требуется индивидуальное редактирование.',
  UpdateVoyageInfoMessage: 'Обновление информации о рейсе. Это также обновит связанные данные в морских экспортных операциях. После подтверждения будет отправлено уведомление по электронной почте:',
  updateBatchTips: 'Обновление информации о рейсе приведет к одновременному обновлению связанных данных в морских экспортных операциях. Подтверждаете?',
  batchUpdateShipSuccess: 'Пакетный перевод судна выполнен успешно',
  Russian: 'Русский',
  Vietnamese: 'Вьетнамский',
  Thai: 'Тайский язык',
  SelectTransshipmentStatusErrorPrompt: 'Поддерживается только пакетное изменение операций положительного бизнеса.',
  NoAccessPermission: 'Нет прав доступа'
}
